import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from './navbar';
import TopNavbar from './topnavbar';
import Footer from './footer';
import '../App.css';
import { Modal, Button } from 'react-bootstrap';
import 'jspdf-autotable';
import * as XLSX from "xlsx";

 function UpdateEmployeeInfo() {
  const navigate = useNavigate();
  const { employeeId } = useParams();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showAddDependentModal, setShowAddDependentModal] = useState(false);
  const [showAddCompBenModal, setShowAddCompBenModal] = useState(false);
  const [employeeData, setEmployeeData] = useState({
    EmployeeId: '',
    EmployeeName: '',
    LastName: '',
    FirstName: '',
    MiddleName: '',
    MaidenName: '',
    Birthdate: '',
    Age: '',
    BirthMonth: '',
    AgeBracket: '',
    Gender: '',
    MaritalStatus: '',
    SSS: '',
    PHIC: '',
    HDMF: '',
    TIN: '',
    ContactNumber: '',
    EmailAddress: '',
    is_Active: false,
    IsActive: false,
    Is_Active: false,
    IsDUHead: false, 
    IsEmergency:false,
    IsIndividualContributor: false,
    IsManager: false,
    IsPMPIC: false,
    IsPermanent: false,
    Is_Emergency: false,
    Is_Permanent: false,
    ProfilePhoto: "/img/user.png",
    HRANType: '',
    Remarks: '',
    HmoProvider: '',
    HmoPolicyNumber: '',
  });
  // Define initialOptions first
  const initialOptions = [
        'Re - Hire',
        'Recall',
        'Resignation',
        'Change of Position Title',
        'Salary Adjustment',
        'Transfer',
        'Force Leave',
        'End of Contract',
        'Extension of Fixed Term',
        'Revert Developmental',
        'Developmental Assignment',
        'Others'
  ];
  const [otherHRANType, setOtherHRANType] = useState('');
  const [options, setOptions] = useState(initialOptions);
  const [initialEmployeeData, setInitialEmployeeData] = useState({});
  const [dependents, setDependents] = useState([]);
  const [selectedDependent, setSelectedDependent] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredDependents, setFilteredDependents] = useState([]);
  const educationRef = useRef(null);
  const [compBenData, setcompBenData] = useState({
    Salary: '',
    DailyEquivalent: '',
    MonthlyEquivalent: '',
    AnnualEquivalent: '',
    RiceMonthly: '',
    RiceAnnual: '',
    RiceDifferentialAnnual: '',
    UniformAnnual: '',
    LeaveDays: '',
    LaundryAllowance: '',
    CommAllowance: '',
    CommAllowanceType: '',
    CashGift: '',
    MedicalInsurance: '',
    FreeHMODependent: '',
    MBL: '',
    LifeInsurance: '',
    Beneficiaries: '',
    PersonalAccidentInsuranceBenefit: '',
    PWDIDNumber: '',
    TendopayRegistered: '',
    CanteenUID: '',
    CanteenCreditLimit: '',
    CanteenBarcode: '',
    DAPMembershipNumber: '',
    DAPDependents: '',
    Stat_SSSNumber: '',
    Stat_SSSMonthlyContribution: '',
    Stat_PagIbigNumber: '',
    Stat_PagIbigMonthlyContribution: '',
    Stat_PHICNumber: '',
    Stat_PHICMonthlyContribution: '',
    Stat_TINNumber: ''
  });
  const [filteredCompBen, setFilteredCompBen] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedCompBen, setSelectedCompBen] = useState(null);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [barangay, setBarangay] = useState([]);
  const [addressErrors, setAddressErrors] = useState({});
  const [ECaddressErrors, setECAddressErrors] = useState({});
  const [ECcountries, setECCountries] = useState([]);
  const [ECregions, setECRegions] = useState([]);
  const [ECprovinces, setECProvinces] = useState([]);
  const [ECcities, setECCities] = useState([]);
  const [ECbarangay, setECBarangay] = useState([]);
    // Initialize state for phone number and validation error
  const [EMphoneError, setEmPhoneError] = useState('');
  const [contactError, setContactError] = useState('');
  const [secondaryContactError, setSecondaryContactError] = useState('');
  const [newContactError, setNewContactError] = useState('');
  const [loggedInLevel, setLoggedInLevel] = useState(null); 
  const [refOptions, setRefOptions] = useState({
    deliveryUnits: [],
    projects: [],
    shifts: [],
    departments: [],
    positions: [],
  });

  useEffect(() => {
    // Fetch and set logged-in user's level from sessionStorage or wherever it's stored
    const level = sessionStorage.getItem('level');
    setLoggedInLevel(level);
  }, []);

  //handles to validate address
  const validateAddressForm = () => {
    const errors = {};
    if (employeeData.Country) {
      if (!employeeData.Province) errors.Province = 'Region is required';
      if (!employeeData.Region) errors.Region = 'Province is required';
      if (!employeeData.CityMunicipality) errors.CityMunicipality = 'City / Municipality is required';
      if (!employeeData.Barangay) errors.Barangay = 'Barangay is required';
      if (!employeeData.ZipCode) errors.ZipCode = 'ZipCode is required';
    }
    setAddressErrors(errors);
    return Object.keys(errors).length === 0;
  };
  
  useEffect(() => {
    updateCompleteAddress();
  }, [ employeeData.Landmark, employeeData.Barangay, employeeData.CityMunicipality, 
    employeeData.Province, employeeData.Region, employeeData.Country, employeeData.ZipCode]);

//handles to validate Emergency contact address
  const validateECAddressForm = () => {
    const errors = {};
    if (employeeData.EmContactCountry) {
      if (!employeeData.EmContactRegion) errors.EmContactRegion = 'Region is required';
      if (!employeeData.EmContactProvince) errors.EmContactProvince = 'Province is required';
      if (!employeeData.EmContactCityMunicipality) errors.EmContactCityMunicipality = 'City / Municipality is required';
      if (!employeeData.EmContactBarangay) errors.EmContactBarangay = 'Barangay is required';
      if (!employeeData.EmContactZipcode) errors.EmContactZipcode = 'ZipCode is required';
    }
    setECAddressErrors(errors);
    return Object.keys(errors).length === 0;
  };
  
  useEffect(() => {
    updateECcompleteAddress();
  }, [employeeData.EmContactLandMark, employeeData.EmContactBarangay, employeeData.EmContactCityMunicipality, employeeData.EmContactProvince, 
    employeeData.EmContactRegion, employeeData.EmContactCountry, employeeData.EmContactZipcode]);

    // Function to handle input change in the search field
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
     // Go back to the previous page in history
  const handleNavigateBack = () => {
    // Navigate back one step in history (equivalent to pressing the browser's back button)
    navigate('/reports', { state: { refreshed: true } });
  };

    // Effect to filter dependents based on search query
    useEffect(() => {
      if (dependents && dependents.length > 0) {
        const filtered = dependents.filter((dependent) =>
          dependent.FullName && dependent.FullName.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredDependents(filtered);
      } else {
        setFilteredDependents([]);
      }
    }, [searchQuery, dependents]);

 // Define the fetchDependents function
 const fetchDependents = async () => {
  try {
    const response = await fetch(`/api/retrieve/dependents/${employeeId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch dependents');
    }
    const data = await response.json();
    setDependents(data);
  } catch (error) {
    console.error('Error fetching dependents:', error);
  }
};

  // Define the fetchCompBen function
  const fetchCompBen = async () => {
    try {
      const response = await fetch(`/api/retrieve/compBen/${employeeId}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch compensation benefits details: ${response.statusText}`);
      }
      const data = await response.json();

          // setcompBenData(data);
          // setCompBen(data); 
          setFilteredCompBen(data);
    } catch (error) {
      console.error('Error fetching compensation benefits details:', error);
    }
  };
  const renderCompBenRows = () => {
    return filteredCompBen.map((compBen, index) => (
      <tr key={index}>
        <td>
          <button className="btn btn-xs btn-primary mr-2" onClick={() => handleShowEditCompBenModal(compBen)}>
            <i className="fas fa-pencil-alt"></i>
          </button>
        </td>
        <td>{shouldShowSalary(employeeData.Level) ? `₱${compBen.Salary}` : 'Salary Hidden'}</td>
        <td>₱{compBen.DailyEquivalent}</td>
        <td>₱{compBen.MonthlyEquivalent}</td>
        <td>₱{compBen.AnnualEquivalent}</td>
        <td>₱{compBen.RiceMonthly}</td>
        <td>₱{compBen.RiceAnnual}</td>
        <td>₱{compBen.RiceDifferentialAnnual}</td>
        <td>₱{compBen.UniformAnnual}</td>
        <td>{compBen.LeaveDays}</td>
        <td>₱{compBen.LaundryAllowance}</td>
        <td>₱{compBen.CommAllowance}</td>
        <td>{compBen.CommAllowanceType}</td>
        <td>₱{compBen.CashGift}</td>
        <td>₱{compBen.MedicalInsurance}</td>
        <td>{compBen.FreeHMODependent}</td>
        <td>₱{compBen.MBL}</td>
        <td>₱{compBen.LifeInsurance}</td>
        <td>{compBen.Beneficiaries}</td>
        <td>{compBen.PersonalAccidentInsuranceBenefit}</td>
        <td>{compBen.PWDIDNumber}</td>
        <td>{compBen.TendopayRegistered}</td>
        <td>{compBen.CanteenUID}</td>
        <td>{compBen.CanteenCreditLimit}</td>
        <td>{compBen.CanteenBarcode}</td>
        <td>{compBen.DAPMembershipNumber}</td>
        <td>{compBen.DAPDependents}</td>
        <td>{compBen.Stat_SSSNumber}</td>
        <td>{compBen.Stat_SSSMonthlyContribution}</td>
        <td>{compBen.Stat_PagIbigNumber}</td>
        <td>{compBen.Stat_PagIbigMonthlyContribution}</td>
        <td>{compBen.Stat_PHICNumber}</td>
        <td>{compBen.Stat_PHICMonthlyContribution}</td>
        <td>{compBen.Stat_TINNumber}</td>
        <td>{compBen.CreatedAt}</td>
      </tr>
    ));
  };

  const shouldShowSalary = (employeeLevel) => {
    if (!loggedInLevel) return false; // Hide if logged-in level is not set
    if (loggedInLevel <= 5 && employeeLevel <= 5) {
      return true; // Show salary if both are 1-5
    }
    if (loggedInLevel >= 6 && loggedInLevel <= 13) {
      return true; // Show all for levels 6-13
    }
    return false; // Hide by default
  };


// Define the History function
const fetchHistory = async () => {
  try {
    const response = await fetch(`/api/retrieve/history/${employeeId}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch history details: ${response.statusText}`);
    }
    const data = await response.json();
    setFilteredHistory(data); // Update the state with fetched data
  } catch (error) {
    console.error('Error fetching history details:', error);
    // Handle error if needed
  }
};
useEffect(() => {
  fetchHistory();
}, [employeeId]);

// Call fetchDependents whenever employeeId changes
useEffect(() => {
  fetchDependents();
  fetchEmployeeData();
  // fetchCompBen();
  fetchRefOptions();
}, [employeeId]);

// Function to format date as 'MM/DD/YYYY'
const formatDateForInput = (date) => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d)) return "";

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
  // Function to reset form data
  const resetFormData = () => {
    setEmployeeData({
      //Dependent fields
      FullName: '',
      PhoneNum: '',
      Relationship: '',
      DateOfBirth: '',
      Occupation: '',
      Address: '',
      City: '',
      DepProvince: '',
      PostalCode: '',
      Beneficiary: '',
      BeneficiaryDate: '',
      TypeOfCoverage: '',
      Insurance: '',
      InsuranceDate: '',
      Remarks: '',
      CompanyPaid: '',
      HMOProvider: '',
      HMOPolicyNumber: ''
    });
  };
    // Function to reset form data
    const resetCompBenForm = () => {
      setcompBenData({
        //Compensation Benefits
        Salary: '',
        DailyEquivalent: '',
        MonthlyEquivalent: '',
        AnnualEquivalent: '',
        RiceMonthly: '',
        RiceAnnual: '',
        RiceDifferentialAnnual: '',
        UniformAnnual: '',
        LeaveDays: '',
        LaundryAllowance: '',
        CommAllowance: '',
        CommAllowanceType: '',
        CashGift: '',
        MedicalInsurance: '',
        FreeHMODependent: '',
        MBL: '',
        LifeInsurance: '',
        Beneficiaries: '',
        PersonalAccidentInsuranceBenefit: '',
        PWDIDNumber: '',
        TendopayRegistered: '',
        CanteenUID: '',
        CanteenCreditLimit: '',
        CanteenBarcode: '',
        DAPMembershipNumber: '',
        DAPDependents: '',
        Stat_SSSNumber: '',
        Stat_SSSMonthlyContribution: '',
        Stat_PagIbigNumber: '',
        Stat_PagIbigMonthlyContribution: '',
        Stat_PHICNumber: '',
        Stat_PHICMonthlyContribution: '',
        Stat_TINNumber: ''
      });
    };
  //Function to handle opening add modal for new dependent records
const handleShowAddDependentModal = () => {
  resetFormData(); // Clear form data
  setShowAddDependentModal(true);
};
const handleShowAddCompBenModal = () => {
  resetCompBenForm(); // Clear form data
  setShowAddCompBenModal(true);
};
//Function to handle closing add modal for new dependent records
const handleCloseAddModal = () => {
  setShowAddDependentModal(false); // Corrected line
  setShowAddCompBenModal(false);
};
  // Function to handle opening edit modal and set selected dependent
  const handleShowEditModal = (dependent) => {
    // setShowEditModal(true);
    setSelectedDependent(dependent);
  };
  // Function to handle closing edit modal
  const handleCloseEditModal = () => {
    // setShowEditModal(false);
    setSelectedDependent(null);
  };
    // Function to handle opening edit modal and set selected dependent
    const handleShowEditCompBenModal = (compBen) => {
      setSelectedCompBen(compBen);
    };
    // Function to handle closing edit modal
    const handleCloseEditCompBenModal = () => {
      setSelectedCompBen(null);
    };

    const fetchRefOptions = async () => {
      const response = await fetch("/api/ref/all");
      const data = await response.json();
      setRefOptions(data);
    };
//FETCHING ALL EMPLOYEE DATA EXCLUDING THE DEPENDENT RECORDS BASED ON EMPLOYEE ID
  const fetchEmployeeData = async () => {
    try {
      const response = await fetch(`/api/retrieve/${employeeId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch employee data');
      }
      const data = await response.json();
    
      // Store the initial employee data
      setInitialEmployeeData(data);

      // Convert birthdate string to formatted date
      data.Birthdate = formatDateForInput(data.Birthdate);
      data.DateHired = formatDateForInput(data.DateHired);
      data.DateFrom = formatDateForInput(data.DateFrom);
      data.DateTo = formatDateForInput(data.DateTo);
      data.DateOfBirth = formatDateForInput(data.DateOfBirth);

      // To convert all the capital letters in a string to title case (capitalize the first letter of each word)
      function convertToTitleCase(str) {
        return str.toLowerCase().replace(/\b\w/g, function (char) {
          return char.toUpperCase();
        });
      }

      // Convert names to title case before setting in state
      const formattedData = {
        ...data,
        EmployeeName: convertToTitleCase(data.EmployeeName),
        FirstName: convertToTitleCase(data.FirstName),
        MiddleName: convertToTitleCase(data.MiddleName),
        LastName: convertToTitleCase(data.LastName),
        BirthMonth: convertToTitleCase(data.BirthMonth),
        MaritalStatus: convertToTitleCase(data.MaritalStatus),
        Gender: convertToTitleCase(data.Gender),
      };

      setEmployeeData(formattedData);
      fetchCompBen();
    } catch (error) {
      console.error('Error fetching employee data:', error);
      setErrorMessage('Error fetching employee data');
    }
  };
  //validate phone number
  const validatePhoneNumber = (value) => {
    const numberRegex = /^[0-9]*$/;
  
    if (!numberRegex.test(value)) {
      return 'Phone number must only contain numbers';
    } else if (value.length > 11) {
      return 'Phone number cannot exceed 11 digits';
    }
  
    return '';
  };
  
//HANDLES INPUT TO UPDATE DATA
const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    let error = '';
    
    // Convert specific fields to booleans if necessary
    switch (name) {
      case 'is_Active':
      case 'IsActive':
      case 'Is_Active':
      case 'IsDUHead':
      case 'IsEmergency':
      case 'IsIndividualContributor':
      case 'IsManager':
      case 'IsPMPIC':
      case 'IsPermanent':
      case 'Is_Emergency':
      case 'Is_Permanent':
        newValue = value === 'true';
        break;
      default:
        break;
    }
        // Phone number validation
        const phoneFields = [
          'EmContactPhoneNumber',
          'ContactNumber',
          'SecondaryContactNum',
          'newContactNumber'
        ];

        if (phoneFields.includes(name)) {
          newValue = value.replace(/\D/g, ''); // numbers only

          if (newValue.length > 11) {
            return; // stop typing more than 11 digits
          }

          error = validatePhoneNumber(newValue);

          if (name === 'EmContactPhoneNumber') setEmPhoneError(error);
          if (name === 'ContactNumber') setContactError(error);
          if (name === 'SecondaryContactNum') setSecondaryContactError(error);
          if (name === 'newContactNumber') setNewContactError(error);
        }

  //  setEmployeeData ({
  //     ...employeeData,
  //     [name]: newValue
  //   });

      setEmployeeData(prev => {
      const updated = { ...prev, [name]: newValue };

      const findItem = (list, key) =>
        list.find(item => item[key] === value);

     if (name === "Position") {
      const item = refOptions.positions.find(item => item.Position === value);
      updated.Level = item?.Level || "";
    }

    if (name === "ProjectCode") {
      const item = refOptions.projects.find(item => item.ProjectCode === value);
      updated.ProjectName = item?.ProjectName || "";
    }

    if (name === "ProjectName") {
      const item = refOptions.projects.find(item => item.ProjectName === value);
      updated.ProjectCode = item?.ProjectCode || "";
    }

    if (name === "DUName") {
    const item = refOptions.deliveryUnits.find(i => i.DUName === value);
    updated.DUCode = item?.DUCode || "";
    }

    if (name === "ShiftCode") {
      const item = refOptions.shifts.find(item => item.ShiftCode === value);
      updated.ShiftName = item?.ShiftName || "";
      updated.ShiftType = item?.ShiftType || "";
    }

    // if (name === "ShiftName") {
    //   const item = refOptions.shifts.find(item => item.ShiftName === value);
    //   updated.ShiftCode = item?.ShiftCode || "";
    //   updated.ShiftType = item?.ShiftType || "";
    // }
      

    if (name === "DepartmentName") {
      const item = refOptions.departments.find(item =>
        item.DepartmentDescription === value ||
        `[${item.DepartmentCode}] ${item.DepartmentDescription}` === value
      );

      updated.DepartmentCode = item?.DepartmentCode || "";
      updated.ProdCode = item?.DepartmentCode || "";
      updated.ProdDesc = item?.DepartmentDescription || "";
    }

    if (name === "Birthdate") {
      const birthDate = new Date(value);

      if (!isNaN(birthDate)) {
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        const birthMonth = birthDate.toLocaleString("default", {
          month: "long",
        });

        let ageBracket = "";

        if (age >= 18 && age <= 24) ageBracket = "18-24";
        else if (age >= 25 && age <= 29) ageBracket = "25-29";
        else if (age >= 30 && age <= 34) ageBracket = "30-34";
        else if (age >= 35 && age <= 39) ageBracket = "35-39";
        else if (age >= 40 && age <= 44) ageBracket = "40-44";
        else if (age >= 45 && age <= 49) ageBracket = "45-49";
        else if (age >= 50 && age <= 54) ageBracket = "50-54";
        else if (age >= 55 && age <= 59) ageBracket = "55-59";
        else if (age >= 60 && age <= 64) ageBracket = "60-64";
        else if (age >= 65) ageBracket = "65 & UP";

        updated.Age = age;
        updated.BirthMonth = birthMonth;
        updated.AgeBracket = ageBracket;
      }
    }

      return updated;
    });

      // Reset otherHRANType if it's not the "Others" option
      if (name === 'HRANType' && value !== 'Others') {
        setOtherHRANType('');
    }
  };
  //handles that validate remarks
  const validateRemarks = () => {
    if (initialOptions.includes(employeeData.HRANType) && employeeData.HRANType !== 'Others' && !employeeData.Remarks) {
      alert('Please enter remarks for the selected HRAN Type.');
      return false;
    }
    return true;
  };
  
  //function to handle the additional input for hran type
  const handleOtherInputChange = (event) => {
    setOtherHRANType(event.target.value);
};
  
//function that handles in adding other hran type details
const addOtherHRANType = () => {
  if (otherHRANType.trim() && !options.includes(otherHRANType)) {
    setOptions([...options, otherHRANType]);
    setEmployeeData({
      ...employeeData,
      HRANType: otherHRANType
    });
    setOtherHRANType('');
  }
};

// Handle form submission for adding new contact
const handleAddContactForm = async (e) => {
  e.preventDefault();

  if (newContactError) {
    alert(newContactError);
    return;
  }
  
  try {
    const contactResponse = await fetch(`/api/addContactNumber/${employeeId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify( employeeData )
    });

    if (!contactResponse.ok) {
      throw new Error('Failed to add new contact number');
    }

    const contactData = await contactResponse.json();

    // Refresh employee data after successful addition
    fetchEmployeeData();

    // Reload the tab
    // window.location.reload();

  } catch (error) {
    console.error('Error adding contact number:', error);
    alert('Failed to add contact number. Please try again.');
  }
};
  //UPDATE EMPLOYEE PERSONAL DETAILS
  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = await fetch(`/api/updateEmployee/${employeeId}`, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(employeeData)
  //     });
  //     if (!response.ok) {
  //       throw new Error('Failed to update employee');
  //     }
  
  //   // Retrieve the name of the employee from employeeData
  //   const { FirstName, LastName } = employeeData;
  //   const employeeName = `${FirstName} ${LastName}`;

  //   // Compare initial employeeData with updated employeeData
  //   const updatedFields = [];
  //   Object.entries(employeeData).forEach(([key, value]) => {
  //     if (value !== initialEmployeeData[key]) {
  //       updatedFields.push(key);
  //     }
  //   });

  //   // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
  //   const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));

  //   // Generate success message based on updated fields
  //   let successMessage;
  //   if (filteredFields.length === 0) {
  //     successMessage = `No employee personal details has been updated for ${employeeName}.`;
  //   } else {
  //     successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
  //   }

  
  //     // Display the success message
  //     alert(successMessage);

  //     // Refresh employee data after successful addition
  //     fetchEmployeeData();

  
  //     } catch (error) {
  //       console.error('Error updating employee personal details:', error);
  //       // Send alert message for failure
  //       alert('Failed to update employee personal details. Please try again later.');
  //     }
  // };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  if (contactError) {
      alert(contactError);
      return;
    }

  if (secondaryContactError) {
    alert(secondaryContactError);
    return;
  }
  try {
    const response = await fetch(`/api/updateEmployeeSection/personalDetails/${employeeId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(employeeData)
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.message);
    }

    const { FirstName, LastName } = employeeData;
    const employeeName = `${FirstName} ${LastName}`;

    const updatedFields = Object.entries(employeeData)
      .filter(([key, value]) => String(value) !== String(initialEmployeeData[key]))
      .map(([key]) => key)
      .filter(field => !['EmployeeName'].includes(field)); // only exclude EmployeeName, not FirstName/MiddleName/LastName

    const msg = updatedFields.length === 0
      ? `No personal details updated for ${employeeName}.`
      : `Employee ${employeeName} updated: ${updatedFields.join(', ')}!`;

    alert(msg);
    fetchEmployeeData();

  } catch (error) {
    console.error('Error updating personal details:', error);
    alert(`Failed to update personal details: ${error.message}`);
  }
};

  // Function to handle in updating the employee information
  // const handleFormEmpInfoSubmit = async (e) => {
  //   e.preventDefault(); // Prevent the default form submission

  //   // Check if HRANType is selected and changed
  //   const isHRANTypeChanged = employeeData.HRANType !== initialEmployeeData.HRANType;

  //   // Validate Remarks only if HRANType is selected and changed
  //   if (isHRANTypeChanged && !validateRemarks()) {
  //     return;
  //   }

  //   try {
  //     // Fetch the current employee data
  //     const currentDataResponse = await fetch(`/api/getEmployeeInfo/${employeeId}`);
  //     if (!currentDataResponse.ok) {
  //       throw new Error('Failed to fetch current employee data');
  //     }
  //     const currentData = await currentDataResponse.json();

  //     // Store previous values for all the fields being updated
  //     const previousValues = { ...currentData };

  //     // Fetch call to update employee information
  //     const response = await fetch(`/api/updateEmployeeInfo/${employeeId}`, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(employeeData),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to update employee');
  //     }

  //     // Retrieve the name of the employee from employeeData
  //     const { FirstName, LastName } = employeeData;
  //     const employeeName = `${FirstName} ${LastName}`;

  //     // Compare initial employeeData with updated employeeData
  //     const updatedFields = [];
  //     Object.entries(employeeData).forEach(([key, value]) => {
  //       if (value !== initialEmployeeData[key]) {
  //         updatedFields.push(key);
  //       }
  //     });

  //     // Filter out fields that should not trigger remarks validation
  //     const filteredFields = updatedFields.filter(
  //       (field) => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName', 'EmContactCompleteAddress'].includes(field)
  //     );

  //     // Generate success message based on updated fields
  //     let successMessage;
  //     if (filteredFields.length === 0) {
  //       successMessage = `No employee information has been updated for ${employeeName}.`;
  //     } else {
  //       successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
  //     }

  //     // Retrieve user's first name from session storage
  //     const updatedByFirstName = sessionStorage.getItem('firstName');
  //     const updatedByLastName = sessionStorage.getItem('lastName');
  //     const updatedByRole = sessionStorage.getItem('role');
  //     const updatedBy = `${updatedByRole} ${updatedByFirstName} ${updatedByLastName}`;

  //     // Insert into History table for each updated field
  //     for (const field of filteredFields) {
  //       const newValue = employeeData[field];
  //       if (newValue === undefined || newValue === null) {
  //         console.error(`Invalid value for field ${field}: ${newValue}`);
  //         continue;
  //       }

  //       const historyData = {
  //         EmployeeName: employeeName,
  //         Action: 'Update',
  //         FieldName: field,
  //         OldValue: previousValues[field] || 'N/A',
  //         NewValue: employeeData[field],
  //         DateCreated: new Date().toISOString(),
  //         UpdatedBy: updatedBy,
  //         EmployeeId: employeeId,
  //         Remarks: isHRANTypeChanged ? employeeData.Remarks : '', // Include Remarks only if HRANType is changed
  //       };

  //       const historyResponse = await fetch('/api/addToHistory', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(historyData),
  //       });

  //       if (!historyResponse.ok) {
  //         throw new Error('Failed to add record to History');
  //       }
  //     }

  //     // Display the success message
  //     alert(successMessage);

  //     // Refresh employee data after successful addition
  //     fetchEmployeeData();

  //   } catch (error) {
  //     console.error('Error updating employee information:', error);
  //     // Send alert message for failure
  //     alert('Failed to update employee information. Please try again later.');
  //   }
  // };

  const handleFormEmpInfoSubmit = async (e) => {
      e.preventDefault();

      const isHRANTypeChanged = employeeData.HRANType !== initialEmployeeData.HRANType;
      if (isHRANTypeChanged && !validateRemarks()) return;

      try {
        const currentDataResponse = await fetch(`/api/getEmployeeInfo/${employeeId}`);
        if (!currentDataResponse.ok) throw new Error('Failed to fetch current employee data');
        const currentData = await currentDataResponse.json();

        // Use the new section endpoint
        const response = await fetch(`/api/updateEmployeeSection/employeeInfo/${employeeId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(employeeData)
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message);
        }

        const { FirstName, LastName } = employeeData;
        const employeeName = `${FirstName} ${LastName}`;

        const updatedFields = Object.entries(employeeData)
          .filter(([key, value]) => String(value) !== String(initialEmployeeData[key]))
          .map(([key]) => key)
          .filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName', 'EmContactCompleteAddress'].includes(field));

        const updatedBy = `${sessionStorage.getItem('role')} ${sessionStorage.getItem('firstName')} ${sessionStorage.getItem('lastName')}`;

        for (const field of updatedFields) {
          const historyData = {
            EmployeeName: employeeName,
            Action: 'Update',
            FieldName: field,
            OldValue: String(currentData[field] ?? 'N/A'),
            NewValue: String(employeeData[field] ?? ''),
            DateCreated: new Date().toISOString(),
            UpdatedBy: updatedBy,
            EmployeeId: employeeId,
            Remarks: isHRANTypeChanged ? employeeData.Remarks : '',
          };

          await fetch('/api/addToHistory', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(historyData)
          });
        }

        const msg = updatedFields.length === 0
          ? `No employee information has been updated for ${employeeName}.`
          : `Employee ${employeeName} has successfully updated ${updatedFields.join(', ')}!`;

        alert(msg);
        fetchEmployeeData();

      } catch (error) {
        console.error('Error updating employee information:', error);
        alert(`Failed to update employee information: ${error.message}`);
      }
    };

      //UPDATE ADDRESS DETAILS
      // const handleAddressFormSubmit = async (e) => {
      //   e.preventDefault(); // Prevent the default form submission
    
      //   if (!validateAddressForm()) {
      //     return; // If validation fails, do not proceed with the API call
      //   }
    
      //   try {
      //     const response = await fetch(`/api/updateEmployeeAddress/${employeeId}`, {
      //       method: 'PUT',
      //       headers: {
      //         'Content-Type': 'application/json'
      //       },
      //       body: JSON.stringify(employeeData)
      //     });
    
      //     if (!response.ok) {
      //       throw new Error('Failed to update employee address');
      //     }
    
      //     // Retrieve the name of the employee from employeeData
      //     const { FirstName, LastName } = employeeData;
      //     const employeeName = `${FirstName} ${LastName}`;
    
      //     // Compare initial employeeData with updated employeeData
      //     const updatedFields = [];
      //     Object.entries(employeeData).forEach(([key, value]) => {
      //       if (value !== initialEmployeeData[key]) {
      //         updatedFields.push(key);
      //       }
      //     });
    
      //     // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
      //     const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));
    
      //     // Generate success message based on updated fields
      //     let successMessage;
      //     if (filteredFields.length === 0) {
      //       successMessage = `No address details have been updated for ${employeeName}.`;
      //     } else {
      //       successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
      //     }
    
      //     // Display the success message
      //     alert(successMessage);
    
      //     // Reload the page after showing the alert
      //     // window.location.reload();
      //     // Navigate to report.js
      //     // navigate("/reports");

      //   // Refresh employee data after successful addition
      //   fetchEmployeeData();
    
      //   } catch (error) {
      //     console.error('Error updating employee address:', error);
      //   } 
      // };

      const handleAddressFormSubmit = async (e) => {
      e.preventDefault();
      if (!validateAddressForm()) return;

      try {
        const response = await fetch(`/api/updateEmployeeSection/employeeContactAddress/${employeeId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(employeeData)
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message || 'Failed to update address');
        }

        const { FirstName, LastName } = employeeData;
        const employeeName = `${FirstName} ${LastName}`;

        const updatedFields = Object.entries(employeeData)
          .filter(([key, value]) => String(value) !== String(initialEmployeeData[key]))
          .map(([key]) => key)
          .filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));

        const msg = updatedFields.length === 0
          ? `No address details updated for ${employeeName}.`
          : `Employee ${employeeName} updated: ${updatedFields.join(', ')}!`;

        alert(msg);
        fetchEmployeeData();

      } catch (error) {
        console.error('Error updating address:', error);
        alert(`Failed to update address: ${error.message}`);
      }
    };

    //UPDATE PROJECT DETAILS
    // const handleProjectFormSubmit = async (e) => {
    //   e.preventDefault();
      
    //   try {
    //     const response = await fetch(`/api/updateProject/${employeeId}`, {
    //       method: 'PUT',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       body: JSON.stringify(employeeData)
    //     });
    //     if (!response.ok) {
    //       throw new Error('Failed to update project details');
    //     }
    
    //   // Retrieve the name of the employee from employeeData
    //   const { FirstName, LastName } = employeeData;
    //   const employeeName = `${FirstName} ${LastName}`;

    //   // Compare initial employeeData with updated employeeData
    //   const updatedFields = [];
    //   Object.entries(employeeData).forEach(([key, value]) => {
    //     if (value !== initialEmployeeData[key]) {
    //       updatedFields.push(key);
    //     }
    //   });

    //   // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
    //   const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));

    //   // Generate success message based on updated fields
    //   let successMessage;
    //   if (filteredFields.length === 0) {
    //     successMessage = `No project details has been updated for ${employeeName}.`;
    //   } else {
    //     successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
    //   }

    
    //     // Display the success message
    //     alert(successMessage);

    //     fetchEmployeeData();
    
    //     // Navigate to report.js
    //   //   navigate("/reports");
    //   } catch (error) {
    //     console.error('Error updating employee:', error);
    //   }
    // };
     //UPDATE EMPLOYEE EDUCATION DETAILS
    // const handleEducationFormSubmit = async (e) => { 
    //     e.preventDefault();
    //     try {
    //       const response = await fetch(`/api/updateEmployeeEducation/${employeeId}`, {
    //         method: 'PUT',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(employeeData)
    //       });
    //       if (!response.ok) {
    //         throw new Error('Failed to update education details');
    //       }
      
    // // Retrieve the name of the employee from employeeData
    // const { FirstName, LastName } = employeeData;
    // const employeeName = `${FirstName} ${LastName}`;

    // // Compare initial employeeData with updated employeeData
    // const updatedFields = [];
    // Object.entries(employeeData).forEach(([key, value]) => {
    //   if (value !== initialEmployeeData[key]) {
    //     updatedFields.push(key);
    //   }
    // });

    // // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
    // const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));

    // // Generate success message based on updated fields
    // let successMessage;
    // if (filteredFields.length === 0) {
    //   successMessage = `No education details has been updated for ${employeeName}.`;
    // } else {
    //   successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
    // }
    //     // Display the success message
    //     alert(successMessage);
      
    //      // Reload the page after showing the alert
    //     // window.location.reload();

    //     // Refresh employee data after successful addition
    //     fetchEmployeeData();

    //     } catch (error) {
    //       console.error('Error updating employee:', error);
    //     }
    //   };
    const handleEducationFormSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await fetch(`/api/updateEmployeeSection/education/${employeeId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(employeeData)
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message || 'Failed to update education');
        }

        const { FirstName, LastName } = employeeData;
        const employeeName = `${FirstName} ${LastName}`;

        const updatedFields = Object.entries(employeeData)
          .filter(([key, value]) => String(value) !== String(initialEmployeeData[key]))
          .map(([key]) => key)
          .filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));

        const msg = updatedFields.length === 0
          ? `No education details updated for ${employeeName}.`
          : `Employee ${employeeName} updated: ${updatedFields.join(', ')}!`;

        alert(msg);
        fetchEmployeeData();

      } catch (error) {
        console.error('Error updating education:', error);
        alert(`Failed to update education: ${error.message}`);
      }
    };
    //UPDATE SHIFT DETAILS
    // const handleShiftFormSubmit = async (e) => {
    //   e.preventDefault();
      
    //   try {
    //     const response = await fetch(`/api/updateShift/${employeeId}`, {
    //       method: 'PUT',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       body: JSON.stringify(employeeData)
    //     });
    //     if (!response.ok) {
    //       throw new Error('Failed to update shift details');
    //     }
    
    //   // Retrieve the name of the employee from employeeData
    //   const { FirstName, LastName } = employeeData;
    //   const employeeName = `${FirstName} ${LastName}`;

    //   // Compare initial employeeData with updated employeeData
    //   const updatedFields = [];
    //   Object.entries(employeeData).forEach(([key, value]) => {
    //     if (value !== initialEmployeeData[key]) {
    //       updatedFields.push(key);
    //     }
    //   });

    //   // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
    //   const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));

    //   // Generate success message based on updated fields
    //   let successMessage;
    //   if (filteredFields.length === 0) {
    //     successMessage = `No shift details has been updated for ${employeeName}.`;
    //   } else {
    //     successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
    //   }

    
    //     // Display the success message
    //     alert(successMessage);

    //     fetchEmployeeData();
    
    //     } catch (error) {
    //       console.error('Error updating shift unit details:', error);
    //       // Send alert message for failure
    //       alert('Failed to update shift unit details. Please try again later.');
    //     }
    // };
    
    //UPDATE DELIVERY UNIT 
    // const handleDUFormSubmit = async (e) => {
    //     e.preventDefault();
        
    //     try {
    //       const response = await fetch(`/api/updateDU/${employeeId}`, {
    //         method: 'PUT',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(employeeData)
    //       });
    //       if (!response.ok) {
    //         throw new Error('Failed to update delivery unit details');
    //       }
      
    //     // Retrieve the name of the employee from employeeData
    //     const { FirstName, LastName } = employeeData;
    //     const employeeName = `${FirstName} ${LastName}`;
    
    //     // Compare initial employeeData with updated employeeData
    //     const updatedFields = [];
    //     Object.entries(employeeData).forEach(([key, value]) => {
    //       if (value !== initialEmployeeData[key]) {
    //         updatedFields.push(key);
    //       }
    //     });
    
    //     // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
    //     const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));
    
    //     // Generate success message based on updated fields
    //     let successMessage;
    //     if (filteredFields.length === 0) {
    //       successMessage = `No delivery unit details has been updated for ${employeeName}.`;
    //     } else {
    //       successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
    //     }
    
    //       // Display the success message
    //       alert(successMessage);
    //       fetchEmployeeData();
      
    //       } catch (error) {
    //         console.error('Error updating delivery unit details:', error);
    //         // Send alert message for failure
    //         alert('Failed to update delivery unit details. Please try again later.');
    //       }
    //   };
       
    //UPDATE DEPARTMENT DETAILS
    // const handleDepartmentFormSubmit = async (e) => {
    //     e.preventDefault();
        
    //     try {
    //       const response = await fetch(`/api/updateDepartment/${employeeId}`, {
    //         method: 'PUT',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(employeeData)
    //       });
    //       if (!response.ok) {
    //         throw new Error('Failed to update employee department details');
    //       }
      
    //     // Retrieve the name of the employee from employeeData
    //     const { FirstName, LastName } = employeeData;
    //     const employeeName = `${FirstName} ${LastName}`;
    
    //     // Compare initial employeeData with updated employeeData
    //     const updatedFields = [];
    //     Object.entries(employeeData).forEach(([key, value]) => {
    //       if (value !== initialEmployeeData[key]) {
    //         updatedFields.push(key);
    //       }
    //     });
    
    //     // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
    //     const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));
    
    //     // Generate success message based on updated fields
    //     let successMessage;
    //     if (filteredFields.length === 0) {
    //       successMessage = `No department details has been updated for ${employeeName}.`;
    //     } else {
    //       successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
    //     }
    //       // Display the success message
    //       alert(successMessage);
    //       fetchEmployeeData();
      
    //       } catch (error) {
    //         console.error('Error updating department details:', error);
    //         // Send alert message for failure
    //         alert('Failed to update department details. Please try again later.');
    //       }
    //   }; 
  // Function to handle dependent form submission for update
  const handleDependentFormSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDependent || !selectedDependent.DependentID) return;
    try {
      const response = await fetch(`/api/updateDependent/${selectedDependent.DependentID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(selectedDependent) // Send updated dependent data
      });

      if (!response.ok) {
        throw new Error('Failed to update dependent details');
      }

      const data = await response.json();
      alert(data.message); // Display success message from backend
      handleCloseEditModal(); // Close modal after successful update
      fetchDependents(); // Refresh dependents data after update

      // Refresh employee data after successful addition
     fetchEmployeeData();

    } catch (error) {
      console.error('Error updating dependent details:', error);
      alert('Failed to update dependent details. Please try again later.');
    }
  };
  //ADD DEPENDENT DETAILS       
  const handleAddDependent = async (e) => {
      e.preventDefault();

      try {
        
        const response = await fetch(`/api/addDependent/${employeeId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(employeeData)
        });

        if (!response.ok) {
          throw new Error('Failed to add dependent details');
        }

        const data = await response.json();
        alert(data.message); // Display success message from backend
        handleCloseAddModal(); // Close modal after successful addition

        // Fetch updated dependents data after adding a new dependent
      fetchDependents(); 

      // Refresh employee data after successful addition
      fetchEmployeeData();

      // Reload the tab
      //  window.location.reload();
      // Close modal
      handleCloseAddModal();

      } catch (error) {
        console.error('Error adding dependent:', error);
        alert('Failed to add dependent. Please try again.');
      }
    };
        //UPDATE PRODUCT DETAILS
      // const handleProductFormSubmit = async (e) => {
      //     e.preventDefault();
          
      //     try {
      //       const response = await fetch(`/api/updateProduct/${employeeId}`, {
      //         method: 'PUT',
      //         headers: {
      //           'Content-Type': 'application/json'
      //         },
      //         body: JSON.stringify(employeeData)
      //       });
      //       if (!response.ok) {
      //         throw new Error('Failed to update product details');
      //       }
        
      //     // Retrieve the name of the employee from employeeData
      //     const { FirstName, LastName } = employeeData;
      //     const employeeName = `${FirstName} ${LastName}`;
      
      //     // Compare initial employeeData with updated employeeData
      //     const updatedFields = [];
      //     Object.entries(employeeData).forEach(([key, value]) => {
      //       if (value !== initialEmployeeData[key]) {
      //         updatedFields.push(key);
      //       }
      //     });
      
      //     // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
      //     const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));
      
      //     // Generate success message based on updated fields
      //     let successMessage;
      //     if (filteredFields.length === 0) {
      //       successMessage = `No product details has been updated for ${employeeName}.`;
      //     } else {
      //       successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
      //     }
      
      //       // Display the success message
      //       alert(successMessage);
      //       fetchEmployeeData();
            
      //       } catch (error) {
      //         console.error('Error updating product details:', error);
      //         // Send alert message for failure
      //         alert('Failed to update product details. Please try again later.');
      //       }
      //   };

      //UPDATE EMERGENCY CONTACT DETAILS
      // const handleECFormSubmit = async (e) => {
      //   e.preventDefault();

      //   if (!validateECAddressForm()) {
      //     return; // If validation fails, do not proceed with the API call
      //   }
      //   try {
      //     const response = await fetch(`/api/updateEmerContact/${employeeId}`, {
      //       method: 'PUT',
      //       headers: {
      //         'Content-Type': 'application/json'
      //       },
      //       body: JSON.stringify(employeeData)
      //     });
      //     if (!response.ok) {
      //       throw new Error('Failed to update employee emergency contact');
      //     }
      
      //     // Retrieve the name of the employee from employeeData
      //     const { FirstName, LastName } = employeeData;
      //     const employeeName = `${FirstName} ${LastName}`;
      
      //     // Compare initial employeeData with updated employeeData
      //     const updatedFields = [];
      //     Object.entries(employeeData).forEach(([key, value]) => {
      //       if (value !== initialEmployeeData[key]) {
      //         updatedFields.push(key);
      //       }
      //     });
      
      //     // Filter out fields that contain EmployeeName, FirstName, MiddleName, LastName
      //     const filteredFields = updatedFields.filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));
      
      //     // Generate success message based on updated fields
      //     let successMessage;
      //     if (filteredFields.length === 0) {
      //       successMessage = `No employee emergency contact details have been updated for ${employeeName}.`;
      //     } else {
      //       successMessage = `Employee ${employeeName} has successfully updated ${filteredFields.join(', ')}!`;
      //     }
      
      //     // Display the success message
      //     alert(successMessage);
      
      //     // Reload the page after showing the alert
      //     // window.location.reload();

      //     // Refresh employee data after successful addition
      //    fetchEmployeeData();

      //   } catch (error) {
      //     console.error('Error updating employee emergency contact:', error);
      //     // Send alert message for failure
      //     alert('Failed to update employee emergency contact. Please try again later.');
      //   }
      // };
      const handleECFormSubmit = async (e) => {
      e.preventDefault();
      if (!validateECAddressForm()) return;

      if (EMphoneError) {
        alert(EMphoneError);
        return;
      }

      try {
        const response = await fetch(`/api/updateEmployeeSection/emergencyContactAddress/${employeeId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(employeeData)
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message || 'Failed to update emergency contact');
        }

        const { FirstName, LastName } = employeeData;
        const employeeName = `${FirstName} ${LastName}`;

        const updatedFields = Object.entries(employeeData)
          .filter(([key, value]) => String(value) !== String(initialEmployeeData[key]))
          .map(([key]) => key)
          .filter(field => !['EmployeeName', 'FirstName', 'MiddleName', 'LastName'].includes(field));

        const msg = updatedFields.length === 0
          ? `No emergency contact details updated for ${employeeName}.`
          : `Employee ${employeeName} updated: ${updatedFields.join(', ')}!`;

        alert(msg);
        fetchEmployeeData();

      } catch (error) {
        console.error('Error updating emergency contact:', error);
        alert(`Failed to update emergency contact: ${error.message}`);
      }
    };

    // Handle navigation to employee profile page with employeeData and dependents
    const handleView = () => {
      navigate('/employeeProfile', { state: { employeeData, dependents } });
    };

    // Define a function to determine the color based on EmployeeStatus value
    const getStatusColor = (status) => {
      switch (status) {
        case 'Active': // Active
          return 'green';
        case 'Separated': // Separated
          return 'red';
        case 'Inactive - Maternity': // Inactive - Maternity
        case 'Inactive - Sickness': // Inactive - Sickness
        case 'Inactive - Absent with leave': // Inactive - Absent with leave
        case 'Inactive - Absent Without Leave': // Inactive - Absent Without Leave
        case 'Inactive - Suspension': // Inactive - Suspension
          return 'gray';
        default:
          return 'black'; // Default color
      }
    };
  
    const statusColor = getStatusColor(employeeData.EmployeeStatus);
    //Address filtering starts here
    useEffect(() => {
      fetchCountries();
    }, []);
  //function to fecth the country in geoname api
    const fetchCountries = async () => {
      const username = 'innodata_test'; // GeoNames username
      try {
        const response = await fetch(`http://api.geonames.org/countryInfoJSON?username=${username}`);
        if (!response.ok) {
          throw new Error('Failed to fetch countries');
        }
        const data = await response.json();
        const countries = data.geonames.map(country => country.countryName);
        setCountries(countries);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
   //function to handle in filtering annd mapping the country
   const handleCountryChange = async (e) => {
    const selectedCountry = e.target.value;
    setEmployeeData({ ...employeeData, Country: selectedCountry });
    setRegions([]);
    setProvinces([]);
    setCities([]);
    setBarangay([]);
    try {
      const username = 'innodata_test';
      const response = await fetch(`http://api.geonames.org/searchJSON?q=${selectedCountry}&featureCode=ADM1&username=${username}`);
      if (!response.ok) {
        throw new Error('Failed to fetch regions data');
      }
      const data = await response.json();
      const regions = data.geonames.map(region => region.name);
      setRegions(regions);
    } catch (error) {
      console.error('Error fetching regions data:', error);
    }
  };

  const handleRegionChange = async (e) => {
    const selectedRegion = e.target.value;
    setEmployeeData({ ...employeeData, Region: selectedRegion });
    setProvinces([]);
    setCities([]);
    setBarangay([]);
    try {
      const username = 'innodata_test';
      const response = await fetch(`http://api.geonames.org/searchJSON?q=${selectedRegion}&featureCode=ADM2&username=${username}`);
      if (!response.ok) {
        throw new Error('Failed to fetch provinces data');
      }
      const data = await response.json();
      const provinces = data.geonames.map(item => item.name);
      setProvinces(provinces);
    } catch (error) {
      console.error('Error fetching provinces data:', error);
    }
  };

  const handleProvinceChange = async (e) => {
    const selectedProvince = e.target.value;
    setEmployeeData({ ...employeeData, Province: selectedProvince });
    setCities([]);
    try {
      const username = 'innodata_test';
      const provinceResponse = await fetch(`http://api.geonames.org/searchJSON?q=${selectedProvince}&featureCode=PPLA&featureCode=PPLA3&username=${username}`);
      if (!provinceResponse.ok) {
        throw new Error('Failed to fetch cities data');
      }
      const provinceData = await provinceResponse.json();
      const provinceCities = provinceData.geonames.map(item => item.name);

      // Fetching highly urbanized cities separately
      const hucResponse = await fetch(`http://api.geonames.org/searchJSON?country=PH&featureCode=PPL&featureCode=PPLA2&featureCode=PPLA3&featureCode=PPLA4&username=${username}`);
      if (!hucResponse.ok) {
        throw new Error('Failed to fetch highly urbanized cities');
      }
      const hucData = await hucResponse.json();
      const hucCities = hucData.geonames
        .filter(item => item.adminName1 === selectedProvince)
        .map(item => item.name);

      const allCities = [...new Set([...provinceCities, ...hucCities])];
      setCities(allCities);
    } catch (error) {
      console.error('Error fetching cities data:', error);
    }
  };

  const handleCityChange = async (e) => {
    const selectedCity = e.target.value;
    setEmployeeData({ ...employeeData, CityMunicipality: selectedCity });
    try {
      const username = 'innodata_test';
      // Fetch places (PPL or PPLX) within the selected city/municipality
      const response = await fetch(`http://api.geonames.org/searchJSON?q=${selectedCity}&featureCode=PPLX&username=${username}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch places data');
      }
      
      const data = await response.json();
      const barangays = data.geonames.map(item => item.name);
      setBarangay(barangays);
      
      // Autofill zip code based on the first entry (if available)
      if (data.geonames.length > 0) {
        const firstBarangay = data.geonames[0].name; // Use the first barangay for zip code lookup
        const zipCode = await fetchZipCode(selectedCity, firstBarangay);
        setEmployeeData(prevData => ({
          ...prevData,
          ZipCode: zipCode || ''
        }));
      }
    } catch (error) {
      console.error('Error fetching places data:', error);
    }
  };
  const fetchZipCode = async (city, barangay) => {
    try {
      const username = 'innodata_test';
      const response = await fetch(`http://api.geonames.org/postalCodeSearchJSON?placename=${barangay}&country=PH&adminCode1=&adminCode2=&adminCode3=&username=${username}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch zip code');
      }
      
      const data = await response.json();
      if (data.postalCodes.length > 0) {
        return data.postalCodes[0].postalCode; // Return the first zip code found
      } else {
        console.warn('No zip code found for the selected barangay');
        return '';
      }
    } catch (error) {
      console.error('Error fetching zip code:', error);
      return '';
    }
  };
//this handles the complete address autofill
  const updateCompleteAddress = () => {
    const { Landmark, Barangay, CityMunicipality, Province, Region, Country, ZipCode } = employeeData;
    const completeAddress = `${Landmark}, ${Barangay}, ${CityMunicipality}, ${Region}, ${Province}, ${Country}, ${ZipCode}`;
    setEmployeeData({ ...employeeData, CompleteAddress: completeAddress });
  };

    const ensureOption = (options, value) => {
      if (value && !options.includes(value)) {
        return [value, ...options];
      }
      return options;
    };
  
    const countriesWithExisting = ensureOption(countries, employeeData.Country);
    const regionsWithExisting = ensureOption(regions, employeeData.Region);
    const provincesWithExisting = ensureOption(provinces, employeeData.Province);
    const citiesWithExisting = ensureOption(cities, employeeData.CityMunicipality);

    //emergency contact address filtering starts here
    useEffect(() => {
      fetchECCountries();
    }, []);
  //function to fecth the country in geoname api
    const fetchECCountries = async () => {
      const username = 'innodata_test'; // GeoNames username
      try {
        const response = await fetch(`http://api.geonames.org/countryInfoJSON?username=${username}`);
        if (!response.ok) {
          throw new Error('Failed to fetch countries');
        }
        const data = await response.json();
        const ECcountries = data.geonames.map(ECcountry => ECcountry.countryName);
        setECCountries(ECcountries);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
   //function to handle in filtering annd mapping the country
   const handleECCountryChange = async (e) => {
    const selectedECCountry = e.target.value;
    setEmployeeData({ ...employeeData, EmContactCountry: selectedECCountry });
    setECRegions([]);
    setECProvinces([]);
    setECCities([]);
    setECBarangay([]);
    try {
      const username = 'innodata_test';
      const response = await fetch(`http://api.geonames.org/searchJSON?q=${selectedECCountry}&featureCode=ADM1&username=${username}`);
      if (!response.ok) {
        throw new Error('Failed to fetch regions data');
      }
      const data = await response.json();
      const regions = data.geonames.map(region => region.name);
      setECRegions(regions);
    } catch (error) {
      console.error('Error fetching regions data:', error);
    }
  };

  const handleECRegionChange = async (e) => {
    const selectedECRegion = e.target.value;
    setEmployeeData({ ...employeeData, EmContactRegion: selectedECRegion });
    setECProvinces([]);
    setECCities([]);
    setECBarangay([]);
    try {
      const username = 'innodata_test';
      const response = await fetch(`http://api.geonames.org/searchJSON?q=${selectedECRegion}&featureCode=ADM2&username=${username}`);
      if (!response.ok) {
        throw new Error('Failed to fetch provinces data');
      }
      const data = await response.json();
      const provinces = data.geonames.map(item => item.name);
      setECProvinces(provinces);
    } catch (error) {
      console.error('Error fetching provinces data:', error);
    }
  };

  const handleECProvinceChange = async (e) => {
    const selectedECProvince = e.target.value;
    setEmployeeData({ ...employeeData, EmContactProvince: selectedECProvince });
    setECCities([]);
    try {
      const username = 'innodata_test';
      const provinceResponse = await fetch(`http://api.geonames.org/searchJSON?q=${selectedECProvince}&featureCode=PPLA&featureCode=PPLA3&username=${username}`);
      if (!provinceResponse.ok) {
        throw new Error('Failed to fetch emergency contact city/municipality data');
      }
      const provinceData = await provinceResponse.json();
      const provinceCities = provinceData.geonames.map(item => item.name);

      // Fetching highly urbanized cities separately
      const hucResponse = await fetch(`http://api.geonames.org/searchJSON?country=PH&featureCode=PPL&featureCode=PPLA2&featureCode=PPLA3&featureCode=PPLA4&username=${username}`);
      if (!hucResponse.ok) {
        throw new Error('Failed to fetch highly urbanized cities');
      }
      const hucData = await hucResponse.json();
      const hucCities = hucData.geonames
        .filter(item => item.adminName1 === selectedECProvince)
        .map(item => item.name);

      const allCities = [...new Set([...provinceCities, ...hucCities])];
      setECCities(allCities);
    } catch (error) {
      console.error('Error fetching city/municipality data:', error);
    }
  };

  const handleECCityChange = async (e) => {
    const selectedECCity = e.target.value;
    setEmployeeData({ ...employeeData, EmContactCityMunicipality: selectedECCity });
    try {
      const username = 'innodata_test';
      // Fetch places (PPL or PPLX) within the selected city/municipality
      const response = await fetch(`http://api.geonames.org/searchJSON?q=${selectedECCity}&featureCode=PPLX&username=${username}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch places data');
      }
      
      const data = await response.json();
      const barangays = data.geonames.map(item => item.name);
      setECBarangay(barangays);
      
      // Autofill zip code based on the first entry (if available)
      if (data.geonames.length > 0) {
        const firstBarangay = data.geonames[0].name; // Use the first barangay for zip code lookup
        const zipCode = await fetchECZipCode(selectedECCity, firstBarangay);
        setEmployeeData(prevData => ({
          ...prevData,
          EmContactZipcode: zipCode || ''
        }));
      }
    } catch (error) {
      console.error('Error fetching places data:', error);
    }
  };
  const fetchECZipCode = async (ECcity, ECbarangay) => {
    try {
      const username = 'innodata_test';
      const response = await fetch(`http://api.geonames.org/postalCodeSearchJSON?placename=${ECbarangay}&country=PH&adminCode1=&adminCode2=&adminCode3=&username=${username}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch zip code');
      }
      
      const data = await response.json();
      if (data.postalCodes.length > 0) {
        return data.postalCodes[0].postalCode; // Return the first zip code found
      } else {
        console.warn('No zip code found for the selected barangay');
        return '';
      }
    } catch (error) {
      console.error('Error fetching zip code:', error);
      return '';
    }
  };

    //this handles the emergency contact complete address autofill
    const updateECcompleteAddress = () => {
      const { EmContactLandMark, EmContactBarangay, EmContactCityMunicipality, EmContactProvince, EmContactRegion, EmContactCountry, EmContactZipcode } = employeeData;
      const completeAddress = `${EmContactLandMark}, ${EmContactBarangay}, ${EmContactCityMunicipality}, ${EmContactProvince }, ${EmContactRegion}, ${EmContactCountry}, ${EmContactZipcode}`;
      setEmployeeData({ ...employeeData, EmContactCompleteAddress: completeAddress });
    };

    const ECensureOption = (options, value) => {
      if (value && !options.includes(value)) {
        return [value, ...options];
      }
      return options;
    };
  
    const ECcountriesWithExisting = ECensureOption(ECcountries, employeeData.EmContactCountry);
    const ECregionsWithExisting = ECensureOption(ECregions, employeeData.EmContactRegion);
    const ECprovincesWithExisting = ECensureOption(ECprovinces, employeeData.EmContactProvince);
    const ECcitiesWithExisting = ECensureOption(ECcities, employeeData.EmContactCityMunicipality);

    
     const positionsWithExisting = (() => {
      const existing = refOptions.positions;
      const hasCurrentPosition = existing.some(i => i.Position === employeeData.Position);
      if (!hasCurrentPosition && employeeData.Position) {
        return [{ Position: employeeData.Position, Level: employeeData.Level }, ...existing];
      }
      return existing;
    })();

    const shiftsWithExisting = (() => {
      const existing = refOptions.shifts;
      const hasCurrentShift = existing.some(i => i.ShiftCode === employeeData.ShiftCode);
      if (!hasCurrentShift && employeeData.ShiftCode) {
        return [
          { ShiftCode: employeeData.ShiftCode, ShiftName: employeeData.ShiftName, ShiftType: employeeData.ShiftType },
          ...existing
        ];
      }
      return existing;
    })();

    const deliveryUnitsWithExisting = (() => {
      const existing = refOptions.deliveryUnits;
      const hasCurrentDU = existing.some(i => i.DUName === employeeData.DUName);
      if (!hasCurrentDU && employeeData.DUName) {
        return [{ DUCode: '', DUName: employeeData.DUName }, ...existing];
      }
      return existing;
    })();

    const projectsWithExisting = (() => {
      const existing = refOptions.projects;
      const hasCurrentProject = existing.some(i => i.ProjectCode === employeeData.ProjectCode);
      if (!hasCurrentProject && employeeData.ProjectCode) {
        return [
          { ProjectCode: employeeData.ProjectCode, ProjectName: employeeData.ProjectName },
          ...existing
        ];
      }
      return existing;
    })();

    const departmentsWithExisting = (() => {
      const existing = refOptions.departments;
      const hasCurrentDept = existing.some(i =>
        `[${i.DepartmentCode}] ${i.DepartmentDescription}` === employeeData.DepartmentName
      );
      if (!hasCurrentDept && employeeData.DepartmentName) {
        return [
          { DepartmentCode: employeeData.DepartmentCode || '', DepartmentDescription: employeeData.DepartmentName },
          ...existing
        ];
      }
      return existing;
    })();

  //array lists all the fields that are mandatory
  const requiredFields = [
    'Salary', 'DailyEquivalent', 'MonthlyEquivalent', 'AnnualEquivalent', 
    'RiceMonthly', 'RiceAnnual', 'RiceDifferentialAnnual', 'UniformAnnual', 
    'LeaveDays', 'LaundryAllowance', 'CommAllowance', 'CashGift', 
    'MedicalInsurance', 'FreeHMODependent', 'MBL', 'LifeInsurance', 
    'PersonalAccidentInsuranceBenefit', 'PWDIDNumber', 'TendopayRegistered', 
    'CanteenUID', 'CanteenCreditLimit', 'CanteenBarcode', 'DAPMembershipNumber', 
    'DAPDependents', 'Stat_SSSNumber', 'Stat_SSSMonthlyContribution', 
    'Stat_PagIbigNumber', 'Stat_PagIbigMonthlyContribution', 'Stat_PHICNumber', 
    'Stat_PHICMonthlyContribution', 'Stat_TINNumber'
  ];
  // function performs validation on each keystroke
    const handleInputCompBenChange = (e) => {
      const { name, value } = e.target;
      let validatedValue = value;
      let error = '';   
  
      switch (name) {
        case 'Salary':
        case 'DailyEquivalent':
        case 'MonthlyEquivalent':
        case 'AnnualEquivalent':
        case 'RiceMonthly':
        case 'RiceAnnual':
        case 'RiceDifferentialAnnual':
        case 'UniformAnnual':
        case 'LeaveDays':
        case 'LaundryAllowance':
        case 'CommAllowance':
        case 'CashGift':
        case 'MedicalInsurance':
        case 'FreeHMODependent':
        case 'MBL':
        case 'LifeInsurance':
        case 'PersonalAccidentInsuranceBenefit':
        case 'CanteenCreditLimit':
        case 'Stat_SSSMonthlyContribution':
        case 'Stat_PagIbigMonthlyContribution':
        case 'Stat_PHICMonthlyContribution':
                // Validation logic for numeric fields
                validatedValue = validatedValue.replace(/[^\d]/g, ''); // Allow only digits
                if (validatedValue === '') {
                  error = `${name} must be a number.`;
                }
          break;
        case 'PWDIDNumber':
        case 'TendopayRegistered':
        case 'CanteenUID':
        case 'CanteenBarcode':
        case 'DAPMembershipNumber':
        case 'Stat_SSSNumber':
        case 'Stat_PagIbigNumber':
        case 'Stat_PHICNumber':
        case 'Stat_TINNumber':
        // Add cases for other alphanumeric fields
        validatedValue = validatedValue.replace(/[^\w]/g, ''); // Allow alphanumeric
        if (validatedValue === '') {
          error = `${name} must be alphanumeric.`;
        }
          break;
        default:
          break;
      }
  
  // Validate if field is required and check if it's empty
  if (!validatedValue && requiredFields.includes(name)) {
    error = `${name} is required.`;
  }

  setcompBenData({
    ...compBenData,
    [name]: validatedValue
  });

  setErrors({
    ...errors,
    [name]: error
  });
};    
//function that handles in adding the compensation benefit record
const handleAddCompBen = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(`/api/addCompBen/${employeeId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(compBenData)
    });

    if (!response.ok) {
      throw new Error('Failed to add compensation benefit details');
    }

    const data = await response.json();
    alert(data.message); // Display success message from backend
    handleCloseAddModal(); // Close modal after successful addition

    //fetch the updated data after adding the compensation benefits details
    fetchCompBen();

    // Fetch updated dependents data after adding a new dependent
    fetchDependents(); 

   // Refresh employee data after successful addition
   fetchEmployeeData();

   // Reload the tab
  //  window.location.reload();
  
  // Close modal
  handleCloseAddModal();

  } catch (error) {
    console.error('Error adding compensation benefit:', error);
    alert('Failed to add compensation benefit. Please try again.');
  }
};
  // Function to handle compensation benefits form submission for update
  const handleEditCompBenFormSubmit = async (e) => {
    e.preventDefault();
    if (!selectedCompBen || !selectedCompBen.CompBenId) return;
    try {
      const response = await fetch(`/api/updateCompBen/${selectedCompBen.CompBenId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(selectedCompBen) // Send updated compensation benefits data
      });

      if (!response.ok) {
        throw new Error('Failed to update compensation benefits details');
      }

      const data = await response.json();
      alert(data.message); // Display success message from backend
      fetchCompBen();
      handleCloseEditCompBenModal(); // Close modal after successful update
       // Refresh compensation benefits data after update

    } catch (error) {
      console.error('Error updating compensation benefits details:', error);
      alert('Failed to update compensation benefits details. Please try again later.');
    }
  };
// Function to format text into sentence case
const toSentenceCase = (text) => {
  if (!text) return ''; // Handle null or undefined input
  return text
    .toLowerCase() // Convert the text to lowercase first
    .split(' ') // Split the text into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words back together
};
// Function to check if a value is a valid date
function isValidDate(dateString) {
  const d = new Date(dateString);
  return !isNaN(d);
}
 //this only download data that are visible in the user interface table
  const handleDownloadExcel = () => {
    // Clone and modify filteredHistory for desired changes
    const modifiedHistory = filteredHistory.map(entry => {
      const { HistoryID, NewValue, OldValue, ...rest } = entry;
      return {
        EmployeeId: entry.EmployeeId,
        EmployeeName: entry.EmployeeName,
        FieldName: entry.FieldName,
        Action: entry.Action,
        Old: OldValue,
        New: NewValue,
        Remarks: entry.Remarks,
        DateCreated: entry.DateCreated,
        UpdatedBy: entry.UpdatedBy
      };
    });
  
    // Apply uppercase to text fields
    const upperCaseHistory = modifiedHistory.map(entry => {
      const newEntry = {};
      for (const key in entry) {
        newEntry[key] = typeof entry[key] === 'string'
          ? entry[key].toUpperCase()
          : entry[key];
      }
      return newEntry;
    });
  
    const ws = XLSX.utils.json_to_sheet(upperCaseHistory);
  
    // Auto-adjust column widths based on the longest cell value in each column
    const colWidths = [];
    const data = [Object.keys(upperCaseHistory[0])].concat(upperCaseHistory.map(obj => Object.values(obj)));
  
    data.forEach(row => {
      row.forEach((val, idx) => {
        const len = val ? val.toString().length : 10;
        if (!colWidths[idx] || len > colWidths[idx].wch) {
          colWidths[idx] = { wch: len };
        }
      });
    });
  
    ws['!cols'] = colWidths;
  
    // Center text in each cell
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
        if (cell) {
          cell.s = {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          };
        }
      }
    }
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "History Report");
  
    XLSX.writeFile(wb, "History_Report.xlsx");
  };

  if (!employeeData) {
    return <div>Loading...</div>;
  }

    return (
      <div id="wrapper">
          <Navbar />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <TopNavbar />
              <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-12 col-xl-9">
              <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <button
                className="seeProfile btn btn-xs mr-2"
                onClick={handleView} >
                <i className="fas fa-eye"></i> View Profile
               </button>
               <div className="d-flex align-items-center">
                  <button
                    className="update-button btn btn-xs mr-2"
                    onClick={handleNavigateBack}
                  >
                    <i className="fas fa-arrow-left"></i> Back
                  </button>
                </div>
              </div>
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                  <ul className="nav nav-tabs nav-fill">
                      <li className="nav-item">
                          <a className="nav-link active " id="personalDetails-tab" data-toggle="tab" href="#personalDetails" role="tab" aria-controls="personalDetails" aria-selected="false">Employee Personal Details</a>
                      </li>
                      <li className="nav-item">
                          <a className="nav-link" id="employmentInfo-tab" data-toggle="tab" href="#employmentInfo" role="tab" aria-controls="employmentInfo" aria-selected="false">Employment Information</a>
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " id="address-tab" data-toggle="tab" href="#address" role="tab" aria-controls="address" aria-selected="false">Address & Contact Info</a>
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " id="education-tab" data-toggle="tab" href="#education" role="tab" aria-controls="education" aria-selected="false">Education</a>
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " id="dependent-tab" data-toggle="tab" href="#dependent" role="tab" aria-controls="dependent" aria-selected="false">Dependent</a>
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " id="compBen-tab" data-toggle="tab" href="#compBen" role="tab" aria-controls="compBen" aria-selected="false">CompBen</a>
                      </li>
                      <li className='nav-item'>
                        <a className='nav-link' id='history-tab' data-toggle='tab' href='#history' role='tab' aria-controls='history' aria-selected='false'>History</a>                       
                      </li>
                  </ul>
                  </div>
                 <br />
                  <div className="tab-content">
                      <div className="tab-pane fade show active" id="personalDetails" role="tabpanel" aria-labelledby="personalDetails-tab">
                          {/* Personal Details Form */}
                        <div className="container">
                        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                        {successMessage && <div className="alert alert-success">{successMessage}</div>}
                            <form onSubmit={handleFormSubmit}>
                            {/* <div className='card-body' id="employee-details-form" ref={personalDetailsRef}> */}
                            <div className='card-body'>
                                <div className="row justify-content-center">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Employee ID</label>
                                            <span className="form-control">{Array.isArray(employeeData.EmployeeId) ? employeeData.EmployeeId[0] : employeeData.EmployeeId}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="emailAddress">Email Address</label>
                                            <input type="text" className="form-control" value={employeeData.EmailAddress} placeholder="enter email address" onChange={handleInputChange} name="EmailAddress" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="name">Full Name</label>
                                            <input type="text" className="form-control" value={employeeData.EmployeeName} onChange={handleInputChange} name="EmployeeName"/>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="lastName">Last Name</label>
                                            <input type="text" className="form-control" value={employeeData.LastName} onChange={handleInputChange} name="LastName"/>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="firstName">First Name</label>
                                            <input type="text" className="form-control" value={employeeData.FirstName} onChange={handleInputChange} name="FirstName"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="middleName">Middle Name</label>
                                            <input type="text" className="form-control" value={employeeData.MiddleName} onChange={handleInputChange} name="MiddleName"/>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="maidenName">Maiden Name</label>
                                            <input type="text" className="form-control" value={employeeData.MaidenName} onChange={handleInputChange} name="MaidenName"/>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="birthdate">Birthdate</label>
                                              {/* <input type="text" className="form-control" value={employeeData.Birthdate} onChange={handleInputChange} name="Birthdate"/> */}
                                              <input
                                              type="date"
                                              className="form-control"
                                              value={employeeData.Birthdate ? new Date(employeeData.Birthdate).toISOString().substr(0, 10) : ''}
                                              placeholder="Birth Date"
                                              name="Birthdate"
                                              onChange={handleInputChange}
                                            />
                                              </div>
                                            </div>
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="age">Age</label>
                                              <input type="number"  className="form-control bg-light" value={employeeData.Age}  readOnly name="Age"/>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="birthMonth">Birth Month</label>
                                              <input type="text" className="form-control bg-light" value={employeeData.BirthMonth} readOnly name="BirthMonth"/>      
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="ageBracket">Age Bracket</label>
                                              <input type="text" className="form-control bg-light" value={employeeData.AgeBracket} readOnly name="AgeBracket"/>
                                              </div>
                                            </div>
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="gender">Gender</label>
                                             <select
                                                className="form-control"
                                                name="Gender"
                                                value={employeeData.Gender || ""}
                                                onChange={handleInputChange}
                                              >
                                                <option value="">Select Gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="maritalStatus">Marital Status</label>
                                              <select
                                                  className="form-control"
                                                  name="MaritalStatus"
                                                  value={employeeData.MaritalStatus || ""}
                                                  onChange={handleInputChange}
                                                >
                                                  <option value="">Select Marital Status</option>
                                                  <option value="Single">Single</option>
                                                  <option value="Married">Married</option>
                                                  <option value="Widowed">Widowed</option>
                                                  <option value="Separated">Separated</option>
                                              </select>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="SSS">SSS No.</label>
                                              <input type="text" className="form-control" value={employeeData.SSS} onChange={handleInputChange} name="SSS"/>     
                                              </div>
                                            </div>
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="PHIC">PHIC</label>
                                              <input type="text" className="form-control" value={employeeData.PHIC} onChange={handleInputChange} name="PHIC"/>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="HDMF">HDMF</label>
                                              <input type="text" className="form-control" value={employeeData.HDMF} onChange={handleInputChange} name="HDMF"/>      
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="TIN">TIN</label>
                                              <input type="text" className="form-control" value={employeeData.TIN} onChange={handleInputChange} name="TIN"/>
                                              </div>
                                            </div>
                                </div>
                                <div className="row justify-content-center">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>HMO Provider</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="HmoProvider"
                                        value={employeeData.HmoProvider || ""}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>HMO Account Number</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="HmoPolicyNumber"
                                        value={employeeData.HmoPolicyNumber || ""}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                                </div>
                                <button type="submit" className="btn btn-primary d-block mx-auto">Save Changes</button>
                            </form>
                        </div>
                      <br/>
                      </div>
                      <div className="tab-pane fade" id="employmentInfo" role="tabpanel" aria-labelledby="employmentInfo-tab">
                          {/* Employment Information Form */}
                          <div className="container">
                            <form onSubmit={handleFormEmpInfoSubmit}>
                            <div className='card-body'>
                              {/* <h5 className='text-primary'>Section 1</h5> */}
                                {/* <hr className="hr-cobalt-blue"/> */}
                                <br/>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="EmpID">Employee Id</label>
                                              <span className="form-control">{Array.isArray(employeeData.EmployeeId) ? employeeData.EmployeeId[0] : employeeData.EmployeeId}</span>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="tenure">Tenure</label>
                                            <input type="text" className="form-control" value={employeeData.Tenure} onChange={handleInputChange} name="Tenure"/> 
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="dateHired">Date Hired</label>
                                           <input
                                              type="date"
                                              className="form-control"
                                              value={employeeData.DateHired || ''}
                                              name="DateHired"
                                              onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                        <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="empStatus">Employee Status</label>
                                                    <select
                                                      value={employeeData.EmployeeStatus}
                                                      name="EmployeeStatus"
                                                      onChange={handleInputChange}
                                                      style={{ color: statusColor }} 
                                                      className='form-control'
                                                    >
                                                        <option value="Active">Active</option>
                                                        <option value="Separated">Separated</option>
                                                        <option value="Inactive - Maternity">Inactive - Maternity</option>
                                                        <option value="Inactive - Sickness">Inactive - Sickness</option>
                                                        <option value="Inactive - Absent with leave">Inactive - Absent with leave</option>
                                                        <option value="Inactive - Absent Without Leave">Inactive - Absent Without Leave</option>
                                                        <option value="Inactive - Suspension">Inactive - Suspension</option>
                                                    </select>
                                                </div>
                                        </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label >Employment Status</label>
                                              <select className= 'form-control' 
                                                    value={employeeData.EmploymentStatus} name="EmploymentStatus" onChange={handleInputChange}>
                                                        <option value="Probationary">Probationary</option>
                                                        <option value="Permanent">Permanent</option>
                                                        <option value="Project">Project</option>
                                                        <option value="Fixed Term">Fixed Term</option>
                                                    </select>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="empCategory"> Employee Category </label>
                                              <select className= 'form-control' 
                                                    value={employeeData.EmployeeCategory} name="EmployeeCategory" onChange={handleInputChange}>
                                                        <option value="Associate">Associate</option>
                                                        <option value="Management">Management</option>
                                                    </select>
                                              </div>
                                            </div>
                                </div>
                                <div className="row justify-content-center">
                                        <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="Role">Employee Role Type</label>
                                                    <select className= 'form-control' 
                                                    value={employeeData.EmployeeRole} name="EmployeeRole" onChange={handleInputChange}>
                                                        <option value="Individual Contributor">Individual Contributor</option>
                                                        <option value="People Manager">People Manager</option>
                                                    </select>
                                                </div>
                                        </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="Rate"> Rate</label>
                                              <input type="text" className="form-control" value={employeeData.Rate} placeholder="enter rate" name="Rate" onChange={handleInputChange} />
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label >Rate Class</label>
                                              <select className= 'form-control' 
                                                    value={employeeData.RateClass} name="RateClass" onChange={handleInputChange}>
                                                        <option value="0">Daily</option>
                                                        <option value="1">Monthly</option>
                                                    </select>
                                              </div>
                                            </div>
                                </div>
                                <div className="row ">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="position">Position</label>
                                                     <select
                                                      className="form-control"
                                                      value={employeeData.Position || ""}
                                                      name="Position"
                                                      onChange={handleInputChange}
                                                    >
                                                      {positionsWithExisting.map((item) => (
                                                        <option
                                                          key={`${item.Position}-${item.Level}`}
                                                          value={item.Position}
                                                        >
                                                          {item.Position}
                                                        </option>
                                                      ))}
                                                    </select>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="positionLevel">Position Level</label>
                                             <input
                                                  type="text"
                                                  className="form-control bg-light"
                                                  value={employeeData.Level || ""}
                                                  readOnly
                                                />
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="facility">Facility</label>
                                              <select className="form-control" value={employeeData.Facility} name="Facility" onChange={handleInputChange}>
                                                        <option value="Mandaue">Mandaue</option>
                                                        <option value="Manila">Manila</option>
                                                        <option value="Legazpi">Legazpi</option>
                                                    </select>
                                              </div>
                                            </div>
                                </div>
                                <div className="row ">
                                    <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="titoType">TITO Type</label>
                                              <input type="text" className="form-control" value={employeeData.TITOType} placeholder="enter tito type" name="TitoType" onChange={handleInputChange} />
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="RoleType">Role</label>
                                              <select className='form-control' 
                                                    value={employeeData.Role} name="Role" onChange={handleInputChange}>
                                                        <option value="HRAdmin">HRAdmin</option>
                                                        <option value="Employee">Employee</option>
                                                    </select>
                                              </div>
                                            </div>
                                </div>
                                <hr/>
                                  {/* <h5 className='text-primary'>Section 2</h5> */}
                                  {/* <hr className="hr-cobalt-blue"/> */}
                                <br/>
                                <div className="row ">
                                <div className="col-md-6">
                                              <div className="form-group">
                                              <label htmlFor="shiftCode"> Shift Code & Name </label>
                                             <select
                                              className="form-control"
                                              value={employeeData.ShiftCode || ""}
                                              name="ShiftCode"
                                              onChange={handleInputChange}
                                            >
                                              {shiftsWithExisting.map(item => (
                                                <option
                                                  key={item.ShiftCode}
                                                  value={item.ShiftCode}
                                                >
                                                  {item.ShiftCode} - {item.ShiftName}
                                                </option>
                                              ))}
                                            </select>
                                              </div>
                                            </div>
                                            {/* <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="shiftname">Shift Name</label>
                                             <select className="form-control" value={employeeData.ShiftName || ""} name="ShiftName" onChange={handleInputChange}>
                                              {refOptions.shifts.map(item => (
                                                <option key={item.ShiftCode} value={item.ShiftName}>
                                                   {item.ShiftName}
                                                </option>
                                              ))}
                                            </select>
                                              </div>
                                            </div> */}
                                            <div className="col-md-6">
                                              <div className="form-group">
                                              <label htmlFor="shifttype">Shift Type</label>
                                              <select className="form-control" value={employeeData.ShiftType || ""} name="ShiftType" onChange={handleInputChange}>
                                                {[...new Set(shiftsWithExisting.map(item => item.ShiftType))].map(type => (
                                                  <option key={type} value={type}>{type}</option>
                                                ))}
                                              </select>
                                              </div>
                                            </div>
                                </div>
                                <div className="row ">
                                            <div className="col-md-6">
                                              <div className="form-group">
                                              <label htmlFor="workWeekType"> Work week type</label>
                                              <select className="form-control" value={employeeData.WorkWeekType} name="WorkWeekType" onChange={handleInputChange}>
                                                        <option value="Non-Compressed Work Week">Non-Compressed Work Week</option>
                                                        <option value="Compressed Work Week (Philippines Facilities)">Compressed Work Week (Philippines Facilities)</option>
                                                    </select>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="form-group">
                                              <label htmlFor="workArrangement">Work Arrangement</label>
                                              <select className="form-control" value={employeeData.WorkArrangement} name="WorkArrangement" onChange={handleInputChange}>
                                                        <option value="WOS">Work On Site</option>
                                                        <option value="WFH">Work From Home</option>
                                                        <option value="Hybrid">Hybrid</option>
                                                    </select>
                                              </div>
                                            </div>
                                            
                                </div>
                                <hr/>
                                  {/* <h5 className='text-primary'>Section 3</h5> */}
                                  {/* <hr className="hr-cobalt-blue"/> */}
                                <br/>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="managerId">Manager Id</label>
                                              <input type="text" className="form-control" value={employeeData.ManagerID} placeholder="enter manager Id" name="ManagerID" onChange={handleInputChange} />   
                                              {/* <span className="form-control">{employeeData.ManagerID}</span> */}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="managerName">Manager Name</label>
                                              <input type="text" className="form-control" value={toSentenceCase(employeeData.ManagerName)} placeholder="enter manager name" name="ManagerName" onChange={handleInputChange} />
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="pmpicid">PM/PIC ID</label>
                                              <input type="text" className="form-control" value={employeeData.PMPICID} placeholder="enter pmpicid" name="PMPICID" onChange={handleInputChange} />
                                              </div>
                                            </div>
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="pmpicIdName">PM/PIC Name</label>
                                              <input type="text" className="form-control" value={employeeData.PMPICIDName} placeholder="enter PMPICID Name" name="PMPICIDName" onChange={handleInputChange} />     
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="duhid">Delivery Unit Head ID</label>
                                              {/* <input type="text" className="form-control" value={employeeData.DUHID} placeholder="enter duhid" name="DUHID" onChange={handleInputChange} /> */}
                                              <span className="form-control">{employeeData.DUHID}</span>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="du">Delivery Unit Head Name</label>
                                              <input type="text" className="form-control" value={employeeData.DUHName} placeholder="enter DUH Name" name="DUHName" onChange={handleInputChange} />
                                              </div>
                                            </div>
                                            
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="duName">Delivery Unit</label>
                                              {/* <input type="text" className="form-control" value={employeeData.DUName} name="DeliveryUnit" /> */}
                                            <select className="form-control" value={employeeData.DUName || ""} name="DUName" onChange={handleInputChange}>
                                              {deliveryUnitsWithExisting.map(item => (
                                                <option key={item.DUCode || item.DUName} value={item.DUName}>
                                                  {item.DUCode ? `${item.DUCode} - ${item.DUName}` : item.DUName}
                                                </option>
                                              ))}
                                            </select>
                                              </div>
                                            </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="projectCode">Project Code</label>
                                            {/* <input type="text" className="form-control" value={employeeData.ProjectCode} placeholder="enter project code" name="ProjectCode" onChange={handleInputChange} /> */}
                                          <select
                                            className="form-control"
                                            value={employeeData.ProjectCode || ""}
                                            name="ProjectCode"
                                            onChange={handleInputChange}
                                          >
                                            <option value="">Select Project Code</option>
                                            {projectsWithExisting.map(item => (
                                              <option key={item.ProjectCode} value={item.ProjectCode}>
                                                {item.ProjectCode}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="projectName">Project Name</label>
                                            {/* <input type="text" className="form-control" value={employeeData.ProjectName} placeholder="enter project name" name="ProjectName" onChange={handleInputChange} /> */}
                                       <select
                                        className="form-control"
                                        value={employeeData.ProjectName || ""}
                                        name="ProjectName"
                                        onChange={handleInputChange}
                                      >
                                        <option value="">Select Project Name</option>
                                        {projectsWithExisting.map(item => (
                                          <option key={item.ProjectCode} value={item.ProjectName}>
                                            {item.ProjectName}
                                          </option>
                                        ))}
                                      </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="productCode">Product Code</label>
                                              <input type="text" className="form-control" value={employeeData.ProdCode} name="ProductCode"  />
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="prodDesc"> Product Description</label>
                                              <input type="text" className="form-control" value={employeeData.ProdDesc} name="ProdDesc" />      
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="department">Department</label>
                                            <select
                                              className="form-control"
                                              value={employeeData.DepartmentName || ""}
                                              name="DepartmentName"
                                              onChange={handleInputChange}
                                            >
                                              
                                              {departmentsWithExisting.map(item => (
                                                <option
                                                  key={item.DepartmentCode || item.DepartmentDescription}
                                                  value={`[${item.DepartmentCode}] ${item.DepartmentDescription}`}
                                                >
                                                  [{item.DepartmentCode}] {item.DepartmentDescription}
                                                </option>
                                              ))}
                                            </select>
                                              </div>
                                            </div>
                                   </div>
                                   <hr/>
                                  {/* <h5 className='text-primary'>Section 4</h5> */}
                                  {/* <hr className="hr-cobalt-blue"/> */}
                                <br/>
                                <div className="row justify-content-center">
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <label htmlFor="HRANType">HRAN Type</label>
                                      <select
                                        className="form-control"
                                        value={employeeData.HRANType}
                                        name="HRANType"
                                        onChange={handleInputChange}
                                      >
                                        {!options.includes(employeeData.HRANType) &&
                                          employeeData.HRANType && (
                                            <option value={employeeData.HRANType}>
                                              {employeeData.HRANType}
                                            </option>
                                        )}

                                        {options.map((option, index) => (
                                          <option key={index} value={option}>
                                            {option}
                                          </option>
                                        ))}
                                      </select>
                                      <br />
                                      {employeeData.HRANType === 'Others' && (
                                        <div className="d-flex align-items-center">
                                          <input
                                            type="text"
                                            className="form-control mr-2"
                                            placeholder="Please specify"
                                            value={otherHRANType}
                                            onChange={handleOtherInputChange}
                                          />
                                          <button type="button" className="btn btn-primary" onClick={addOtherHRANType}>Add</button>
                                        </div>
                                      )}
                                      {employeeData.HRANType !== 'Others' && employeeData.HRANType && (
                                        <div className="form-group mt-3">
                                          <label htmlFor="Remarks">Remarks</label>
                                          <textarea
                                            className="form-control"
                                            name="Remarks"
                                            value={employeeData.Remarks}
                                            onChange={handleInputChange}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <label htmlFor="isManager">Is Manager</label>
                                      <select className="form-control" value={employeeData.IsManager} name="IsManager" onChange={handleInputChange}>
                                        <option value={true}>Yes</option>
                                        <option value={false}>No</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <label htmlFor="isPmpic">Is PMPIC</label>
                                      <select className="form-control" value={employeeData.IsPMPIC} name="IsPMPIC" onChange={handleInputChange}>
                                        <option value={true}>Yes</option>
                                        <option value={false}>No</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                  {/* <div className="row justify-content-center">
                                              <div className="col-md-4">
                                                <div className="form-group">
                                                <label htmlFor="HRANType">HRAN Type</label>
                                                            <select
                                                                className="form-control"
                                                                value={employeeData.HRANType}
                                                                name="HRANType"
                                                                onChange={handleInputChange}
                                                            >
                                                                {options.map((option, index) => (
                                                                    <option key={index} value={option}>
                                                                        {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <br />
                                                            {employeeData.HRANType === 'Others' && (
                                                                <div className="d-flex align-items-center">
                                                                  <input
                                                                      type="text"
                                                                      className="form-control mr-2"
                                                                      placeholder="Please specify"
                                                                      value={otherHRANType}
                                                                      onChange={handleOtherInputChange}
                                                                  />
                                                                     <button type="button" className="btn btn-primary" onClick={addOtherHRANType}>Add</button>
                                                                </div>
                                                            )}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="isManager">Is Manager</label>
                                              <select className="form-control" value={employeeData.IsManager} name="IsManager" onChange={handleInputChange}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>
                                              </div>
                                            </div>
                                <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="isPmpic">Is PMPIC</label>
                                              <select className="form-control" value={employeeData.IsPMPIC} name="IsPMPIC" onChange={handleInputChange}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>
                                              </div>
                                            </div>
                                </div> */}
                                <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="isIndContributor">Is Individual Contributor</label>
                                              <select className="form-control" value={employeeData.IsIndividualContributor} name="IsIndividualContributor" onChange={handleInputChange}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="isActive">Is Active</label>
                                              <select className="form-control" value={employeeData.IsActive} name="IsActive" onChange={handleInputChange}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>
                                              </div>
                                            </div>
                                              <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="isDuHead">Is DU Head</label>
                                                    <select className="form-control" value={employeeData.IsDUHead} name="IsDUHead" onChange={handleInputChange}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>
                                                </div>
                                     </div>
                                </div> 
                                </div>
                                <button type="submit" className="btn btn-primary d-block mx-auto">Save Changes</button>
                            </form>
                        </div>
                      <br/>
                      </div>
                      <div className="tab-pane fade" id="address" role="tabpanel" aria-labelledby="address-tab">
                                    {/* Address Form */}
                                    <div className="container">
                                      <h5 className="text-primary">Contact Details</h5>
                                      <hr className="hr-cobalt-blue" />
                                      <br />
                                      <div className="row">
                                    <form onSubmit={handleFormSubmit}>
                                      <div className="form-group">
                                        <label>Update Contact Number</label>
                                        <div className="d-flex align-items-center">
                                          <input
                                            type="text"
                                            className={`form-control mr-2 ${contactError && 'is-invalid'}`}
                                            value={employeeData.ContactNumber}
                                            placeholder="update contact number"
                                            name="ContactNumber"
                                            maxLength={11}
                                            onChange={handleInputChange}
                                          />
                                          {contactError && <div className="invalid-feedback">{contactError}</div>}
                                          <button type="submit" className="btn btn-primary">
                                            <i className="fas fa-pencil-alt"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </form>
                                    {employeeData.SecondaryContactNum && employeeData.SecondaryContactNum !== 'N/A' && (
                                      <div className="col-md-4">
                                        <div>
                                          <label>Secondary Contact Number</label>
                                          <span className="form-control">{employeeData.SecondaryContactNum}</span>
                                        </div>
                                      </div>
                                    )}
                                    <div className="col-md-4">
                                      <form onSubmit={handleAddContactForm}>
                                        <div className="form-group">
                                          {employeeData.SecondaryContactNum ? (
                                            <>
                                              <label>Update Secondary Contact Number</label>
                                              <div className="d-flex align-items-center">
                                                <input
                                                  type="tel"
                                                  className={`form-control mr-2 ${newContactError && 'is-invalid'}`}
                                                  value={employeeData.newContactNumber}
                                                  placeholder="update contact number"
                                                  name="newContactNumber"
                                                  onChange={handleInputChange}
                                                />
                                                {newContactError && <div className="invalid-feedback">{newContactError}</div>}
                                                <button type="submit" className="btn btn-primary">
                                                  <i className="fas fa-pencil-alt"></i>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <label>Add New Contact Number</label>
                                              <div className="d-flex align-items-center">
                                                <input
                                                  type="tel"
                                                  className={`form-control mr-2 ${newContactError && 'is-invalid'}`}
                                                  value={employeeData.newContactNumber}
                                                  placeholder="add new contact number"
                                                  name="newContactNumber"
                                                  onChange={handleInputChange}
                                                />
                                                {newContactError && <div className="invalid-feedback">{newContactError}</div>}
                                                <button type="submit" className="btn btn-primary">
                                                  <i className="fas fa-plus"></i>
                                                </button>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                    <hr/>
                                      <form onSubmit={handleAddressFormSubmit}>
                                        <h5 className='text-primary'>Address Details</h5>
                                        <hr className="hr-cobalt-blue"/>
                                        <br/>
                                        <div className="row">
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="houseNumber">House Number</label>
                                              <input type="text" className="form-control" placeholder="enter house number" value={employeeData.HouseNumber} name="HouseNumber" onChange={handleInputChange} />
                                            </div>
                                          </div>
                                          <div className="col-md-8">
                                            <div className="form-group">
                                              <label htmlFor="completeAddress">Complete Address</label>
                                              <input type="text" className="form-control" placeholder="Enter Complete Address" name="CompleteAddress" value={employeeData.CompleteAddress} onChange={handleInputChange} />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row justify-content-center">
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="country">Country</label>
                                              <select
                                                id="countryDropdown"
                                                className="form-control"
                                                value={employeeData.Country || ""}
                                                name="Country"
                                                onChange={handleCountryChange}
                                              >
                                                {countriesWithExisting.map(country => (
                                                  <option key={country} value={country}>{country}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="region">Region</label>
                                              <select
                                                id="regionDropdown"
                                                className="form-control"
                                                value={employeeData.Region || ""}
                                                name="Region"
                                                onChange={handleRegionChange}
                                              >
                                                {regionsWithExisting.map(region => (
                                                  <option key={region} value={region}>{region}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="province">Province</label>
                                              <select
                                                id="provinceDropdown"
                                                className="form-control"
                                                value={employeeData.Province || ""}
                                                name="Province"
                                                onChange={handleProvinceChange}
                                              >
                                                {provincesWithExisting.map(province => (
                                                  <option key={province} value={province}>{province}</option>
                                                ))}
                                              </select>
                                              {addressErrors.Province && <div className="text-danger">{addressErrors.Province}</div>}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row justify-content-center">
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="cityMunicipality">City / Municipality</label>
                                              <select
                                                id="cityDropdown"
                                                className="form-control"
                                                value={employeeData.CityMunicipality || ""}
                                                name="CityMunicipality"
                                                onChange={handleCityChange}
                                              >
                                                {citiesWithExisting.map(city => (
                                                  <option key={city} value={city}>{city}</option>
                                                ))}
                                              </select>
                                              {addressErrors.CityMunicipality && <div className="text-danger">{addressErrors.CityMunicipality}</div>}
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="brgy">Barangay</label>
                                              <input type="text" className="form-control" placeholder="Enter Barangay" name="Barangay" value={employeeData.Barangay} onChange={handleInputChange} />
                                              {addressErrors.Barangay && <div className="text-danger">{addressErrors.Barangay}</div>}
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="zipcode">Zip Code</label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Zip Code"
                                                name="ZipCode"
                                                value={employeeData.ZipCode}
                                                onChange={handleInputChange}
                                              />
                                              {addressErrors.ZipCode && <div className="text-danger">{addressErrors.ZipCode }</div>}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row justify-content-center">
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="landmark">Land Mark</label>
                                              <input type="text" className="form-control" placeholder="Enter Land Mark" name="Landmark" value={employeeData.Landmark} onChange={handleInputChange} />
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="isPermanent">is Permanent</label>
                                              <select className="form-control" value={employeeData.IsPermanent} name="IsPermanent" onChange={handleInputChange}>
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                              </select>
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <label htmlFor="isEmergency">is Emergency</label>
                                              <select className="form-control" value={employeeData.IsEmergency} name="IsEmergency" onChange={handleInputChange}>
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary d-block mx-auto">Save Changes</button>
                                      </form>
                            <hr/>
                            <h5 className='text-primary'>Emergency Contact Details</h5>
                                <hr className="hr-cobalt-blue"/>
                                <br/>
                            <form onSubmit={handleECFormSubmit}>
                            <div className='card-body'>
                                <div className="row justify-content-center">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Full Name</label>
                                            <input type="text" className="form-control" value={employeeData.EmContactFullName} placeholder="Enter full name" name="EmContactFullName" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-group">
                                          <label>Phone Number</label>
                                          <input 
                                            type="text" 
                                            className={`form-control ${EMphoneError ? 'is-invalid' : ''}`} 
                                            value={employeeData.EmContactPhoneNumber} 
                                            placeholder="Enter contact number" 
                                            name="EmContactPhoneNumber" 
                                            onChange={handleInputChange} 
                                        />
                                        {EMphoneError && <div className="invalid-feedback">{EMphoneError}</div>}
                                      </div>
                                  </div>
                                  <div className="col-md-4">
                                        <div className="form-group">
                                            <label>House Number</label>
                                            <input type="text" className="form-control" value={employeeData.EmContactHouseNo} placeholder="Enter house number" name="EmContactHouseNo" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Complete Address</label>
                                            <input type="text" className="form-control" value={employeeData.EmContactCompleteAddress} placeholder="Enter complete address" name="EmContactCompleteAddress" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Country</label>
                                            <select
                                                id="countryDropdown"
                                                className="form-control"
                                                value={employeeData.EmContactCountry || ""}
                                                name="EmContactCountry"
                                                onChange={handleECCountryChange}
                                              >
                                                {ECcountriesWithExisting.map(country => (
                                                  <option key={country} value={country}>{country}</option>
                                                ))}
                                              </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Region</label>
                                             <select
                                                id="regionDropdown"
                                                className="form-control"
                                                value={employeeData.EmContactRegion || ""}
                                                name="EmContactRegion"
                                                onChange={handleECRegionChange}
                                              >
                                                {ECregionsWithExisting.map(region => (
                                                  <option key={region} value={region}>{region}</option>
                                                ))}
                                              </select>
                                              {ECaddressErrors.EmContactRegion && <div className="text-danger">{ECaddressErrors.EmContactRegion}</div>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Province</label>
                                            <select
                                                id="provinceDropdown"
                                                className="form-control"
                                                value={employeeData.EmContactProvince || ""}
                                                name="EmContactProvince"
                                                onChange={handleECProvinceChange}
                                              >
                                                {ECprovincesWithExisting.map(province => (
                                                  <option key={province} value={province}>{province}</option>
                                                ))}
                                              </select>
                                              {ECaddressErrors.EmContactProvince && <div className="text-danger">{ECaddressErrors.EmContactProvince}</div>}
                                       </div>
                                    </div>
                                </div>
                                  <div className="row justify-content-center">
                                  <div className="col-md-4">
                                    <div className="form-group">
                                              <label htmlFor="ECcityMunicipality">City / Municipality</label>
                                              <select
                                                id="municipalityDropdown"
                                                className="form-control"
                                                value={employeeData.EmContactCityMunicipality || ""}
                                                name="EmContactCityMunicipality"
                                                onChange={handleECCityChange}
                                              >
                                                {ECcitiesWithExisting.map(municipality => (
                                                  <option key={municipality} value={municipality}>{municipality}</option>
                                                ))}
                                              </select>
                                              {ECaddressErrors.EmContactCityMunicipality && <div className="text-danger">{ECaddressErrors.EmContactCityMunicipality}</div>}
                                            </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Barangay</label>
                                            <input type="text" className="form-control" value={employeeData.EmContactBarangay} placeholder="Enter Barangay" name="EmContactBarangay" onChange={handleInputChange} />
                                            {ECaddressErrors.EmContactBarangay && <div className="text-danger">{ECaddressErrors.EmContactBarangay}</div>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Zip Code</label>
                                            <input type="text" className="form-control" value={employeeData.EmContactZipcode} placeholder="Enter zip code" name="EmContactZipcode" onChange={handleInputChange} />
                                            {ECaddressErrors.EmContactZipcode && <div className="text-danger">{ECaddressErrors.EmContactZipcode}</div>}
                                        </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                  <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Land Mark</label>
                                            <input type="text" className="form-control" value={employeeData.EmContactLandMark} placeholder="Enter landmark" name="EmContactLandMark" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Is Permanent</label>
                                            <select className="form-control" value={employeeData.Is_Permanent} name="Is_Permanent" onChange={handleInputChange}>
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Is Emergency</label>
                                            <select className="form-control" value={employeeData.Is_Emergency} name="Is_Emergency" onChange={handleInputChange}>
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                            </select>
                                        </div>
                                      </div>
                                   </div>
                                </div>
                                <br/>
                                <button type="submit" className="btn btn-primary d-block mx-auto">Save Changes</button>
                            </form>
                        </div>
                      <br/>
                      </div>
                      <div className="tab-pane fade" id="education" role="tabpanel" aria-labelledby="education-tab">
                          {/* Education Form */}
                          <div className="container">
                            <form onSubmit={handleEducationFormSubmit}>
                            <div className='card-body' ref={educationRef}>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                        <div className="form-group">
                                            <label> School </label>
                                            <input type="text" className="form-control" value={employeeData.School} placeholder="Enter School" name="School" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Education Level</label>
                                            <input type="text" className="form-control" value={employeeData.EducationLevel} placeholder="Enter Education Level" name="EducationLevel" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Degree</label>
                                            <input type="text" value={employeeData.Degree} className="form-control" placeholder="Enter Degree" name="Degree" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="majorCourse">Major course</label>
                                            <input type="text" className="form-control" value={employeeData.MajorCourse} placeholder="Enter Major Course" name="MajorCourse" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="honorRank">Honor Rank</label>
                                            <input type="text" className="form-control" value={employeeData.HonorRank} placeholder="Enter Honor Rank" name="HonorRank" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-4">
                                              <div className="form-group">
                                              <label htmlFor="session">Session</label>
                                              <input type="text" className="form-control" value={employeeData.Session} placeholder="Enter Session" name="Session" onChange={handleInputChange} />
                                              </div>
                                            </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="dateFrom">Date From</label>
                                            {/* <input type="text" className="form-control" value={employeeData.DateFrom} placeholder="Enter date From" name="DateFrom" onChange={handleInputChange} /> */}
                                            <input
                                              type="date"
                                              className="form-control"
                                              value={employeeData.DateFrom ? new Date(employeeData.DateFrom).toISOString().substr(0, 10) : ''}
                                              placeholder="Date From"
                                              name="DateFrom"
                                              onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                        <label htmlFor="dateTo">Date To</label>
                                            {/* <input type="text" className="form-control" value={employeeData.DateTo} placeholder="Enter date To" name="DateTo" onChange={handleInputChange} /> */}
                                            <input
                                              type="date"
                                              className="form-control"
                                              value={employeeData.DateTo ? new Date(employeeData.DateTo).toISOString().substr(0, 10) : ''}
                                              placeholder="Date To"
                                              name="BirthdDateToate"
                                              onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="monthCompleted">Month Completed</label>
                                            <input type="text" className="form-control" value={employeeData.MonthCompleted} placeholder="Enter Month Completed" name="MonthCompleted" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                <div className="col-md-4">
                                        <div className="form-group">
                                        <label>Units Earned</label>
                                            <input type="text" className="form-control" value={employeeData.UnitsEarned} placeholder="Enter Units Earned" name="UnitsEarned" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                        <label htmlFor="completed">Completed</label>
                                            <input type="text" className="form-control" value={employeeData.Completed} placeholder="Enter Completed" name="Completed" onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <button type="submit" className="btn btn-primary d-block mx-auto">Save Changes</button>
                            </form>
                        </div>
                      <br/>
                      </div>
                      <div className="tab-pane fade" id="dependent" role="tabpanel" aria-labelledby="dependent-tab">
                        {/* Dependent Form */}
                                <div className="card-body d-flex justify-content-between align-items-center">
                                  {/* New Record button */}
                                  <button className="btn btn-xs btn-primary mr-2" onClick={handleShowAddDependentModal}>
                                    <i className="fas fa-plus"></i> New Record
                                  </button>

                                  {/* Search form */}
                                  <form className="form-inline ml-auto">
                                  <div className="input-group-append">
                                        <button className="btn btn-primary" type="button">
                                          <i className="fas fa-search fa-sm"></i>
                                        </button>
                                      </div>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        className="form-control bg-light border-0 small"
                                        placeholder="Search by Name"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                      />
                                    </div>
                                  </form>
                                </div>
                              {/* Add Dependent Modal */}
                              <Modal show={showAddDependentModal} onHide={handleCloseAddModal} dialogClassName="custom-modal">
                                  <Modal.Header>
                                      <Modal.Title>Add New Dependent</Modal.Title>
                                      <Button variant="default" onClick={handleCloseAddModal}> X </Button>
                                  </Modal.Header>
                                  <Modal.Body>
                                      {/*  adding new dependent form*/}
                                      <form >
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Full Name</label>
                                                                  <input type="text" className="form-control" value={employeeData.FullName} placeholder="enter dependent full name" name="FullName" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Phone Number</label>
                                                                  <input type="tel" className="form-control" value={employeeData.PhoneNum} placeholder="Enter Phone Number" name="PhoneNum" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Relationship</label>
                                                                  <input type="text" className="form-control" value={employeeData.Relationship} placeholder="enter relationship" name="Relationship" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label>Date of Birth</label>
                                                                  <input type="date" className="form-control" value={employeeData.DateOfBirth} placeholder="enter date of birth" name="DateOfBirth" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Occupation</label>
                                                                  <input type="text" className="form-control" value={employeeData.Occupation} placeholder="enter  occupation" name="Occupation" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Address</label>
                                                                  <input type="text" className="form-control" value={employeeData.Address} placeholder="Enter address" name="Address" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label>City</label>
                                                                  <input type="text" className="form-control" value={employeeData.City} placeholder="Enter City" name="City" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label>Province</label>
                                                                  <input type="text" className="form-control" value={employeeData.DepProvince} placeholder="Enter Province" name="DepProvince" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >Postal Code</label>
                                                                    <input type="text" className="form-control" value={employeeData.PostalCode} placeholder="Enter Postal Code" name="PostalCode" onChange={handleInputChange} />
                                                                    </div>
                                                                  </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Beneficiary</label>
                                                                  <input type="text" className="form-control" value={employeeData.Beneficiary} placeholder="Enter Beneficiary" name="Beneficiary" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >Beneficiary Date</label>
                                                                    <input type="date" className="form-control" value={employeeData.BeneficiaryDate} placeholder="Enter Beneficiary Date" name="BeneficiaryDate" onChange={handleInputChange} />
                                                                    </div>
                                                                  </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Type of coverage</label>
                                                                  <input type="text" className="form-control" value={employeeData.TypeOfCoverage} placeholder="Enter Type of coverage" name="TypeOfCoverage" onChange={handleInputChange} />
                                                          </div>
                                                          </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Insurance</label>
                                                                  <input type="text" className="form-control" value={employeeData.Insurance} placeholder="Enter Insurance" name="Insurance" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Insurance Date</label>
                                                                  <input type="date" className="form-control" value={employeeData.InsuranceDate} placeholder="Enter Insurance Date" name="InsuranceDate" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >Remarks</label>
                                                                    <input type="text" className="form-control" value={employeeData.Remarks} placeholder="Enter Remarks" name="Remarks" onChange={handleInputChange} />
                                                                    </div>
                                                                  </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Company Paid</label>
                                                                  <input type="text" className="form-control" value={employeeData.CompanyPaid} placeholder="Enter Company Paid" name="CompanyPaid" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >HMO Provider</label>
                                                                  <input type="text" className="form-control" value={employeeData.HMOProvider} placeholder="Enter HMO Provider" name="HMOProvider" onChange={handleInputChange} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >HMO Policy Number</label>
                                                                    <input type="text" className="form-control" value={employeeData.HMOPolicyNumber} placeholder="Enter HMO Policy Number" name="HMOPolicyNumber" onChange={handleInputChange} />
                                                                    </div>
                                                                  </div>
                                                      </div>
                                                      <br/>
                                      </form>
                                  </Modal.Body>
                                  <Modal.Footer>
                                      <Button variant="secondary" onClick={handleCloseAddModal}>
                                          Close
                                      </Button>
                                      <Button variant="primary" onClick={handleAddDependent}>
                                          Add Dependent
                                      </Button>
                                  </Modal.Footer>
                              </Modal>
                              {/* Edit Dependent Modal */}
                            <Modal show={!!selectedDependent} onHide={handleCloseEditModal} dialogClassName="custom-modal">
                              <Modal.Header>
                                <Modal.Title>Update Dependent Records</Modal.Title>
                                <Button variant="default" onClick={handleCloseEditModal}> X </Button>
                              </Modal.Header>
                              <Modal.Body>
                                      {/*  edit dependent form*/}
                                      <form>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Full Name</label>
                                                                  <input type="text" className="form-control" placeholder="enter dependent full name" value={selectedDependent?.FullName || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, FullName: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Phone Number</label>
                                                                  <input type="text" className="form-control" placeholder="Enter Phone Number" value={selectedDependent?.PhoneNum || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, PhoneNum: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Relationship</label>
                                                                  <input type="text" className="form-control" placeholder="enter relationship" value={selectedDependent?.Relationship || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, Relationship: e.target.value })} />
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label>Date of Birth</label>
                                                                  <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={selectedDependent && selectedDependent.DateOfBirth && isValidDate(selectedDependent.DateOfBirth) ? new Date(selectedDependent.DateOfBirth).toISOString().substr(0, 10) : ''}
                                                                    placeholder="Date Of Birth"
                                                                    onChange={(e) => {
                                                                      const newValue = e.target.value !== '' ? e.target.value : null;
                                                                      setSelectedDependent({ ...selectedDependent, DateOfBirth: newValue });
                                                                    }}
                                                                  />
                                                                  {/* <input type="date" className="form-control" placeholder="enter date of birth" value={selectedDependent?.DateOfBirth || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, DateOfBirth: e.target.value })} /> */}
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Occupation</label>
                                                                  <input type="text" className="form-control" placeholder="enter  occupation" value={selectedDependent?.Occupation || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, Occupation: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Address</label>
                                                                  <input type="text" className="form-control" placeholder="Enter address" value={selectedDependent?.Address || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, Address: e.target.value })}/>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label>City</label>
                                                                  <input type="text" className="form-control" placeholder="Enter City" value={selectedDependent?.City || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, City: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label>Province</label>
                                                                  <input type="text" className="form-control" placeholder="Enter Province" value={selectedDependent?.DepProvince || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, DepProvince: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >Postal Code</label>
                                                                    <input type="text" className="form-control" placeholder="Enter Postal Code" value={selectedDependent?.PostalCode || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, PostalCode: e.target.value })}/>
                                                                    </div>
                                                                  </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Beneficiary</label>
                                                                  <input type="text" className="form-control" placeholder="Enter Beneficiary" value={selectedDependent?.Beneficiary || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, Beneficiary: e.target.value })}/>
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >Beneficiary Date</label>
                                                                   <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={selectedDependent && selectedDependent.BeneficiaryDate && isValidDate(selectedDependent.BeneficiaryDate) ? new Date(selectedDependent.BeneficiaryDate).toISOString().substr(0, 10) : ''}
                                                                    placeholder="Beneficiary Date"
                                                                    onChange={(e) => {
                                                                      const newValue = e.target.value !== '' ? e.target.value : null;
                                                                      setSelectedDependent({ ...selectedDependent, BeneficiaryDate: newValue });
                                                                    }}
                                                                  />
                                                                    {/* <input type="date" className="form-control" placeholder="Enter Beneficiary Date" value={selectedDependent?.BeneficiaryDate || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, BeneficiaryDate: e.target.value })} /> */}
                                                                    </div>
                                                                  </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Type of coverage</label>
                                                                  <input type="text" className="form-control" placeholder="Enter Type of coverage" value={selectedDependent?.TypeOfCoverage || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, TypeOfCoverage: e.target.value })} />
                                                          </div>
                                                          </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Insurance</label>
                                                                  <input type="tel" className="form-control" placeholder="Enter Insurance" value={selectedDependent?.Insurance || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, Insurance: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Insurance Date</label>
                                                                  <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={selectedDependent && selectedDependent.InsuranceDate && isValidDate(selectedDependent.InsuranceDate) ? new Date(selectedDependent.BeneficiaryDate).toISOString().substr(0, 10) : ''}
                                                                    placeholder="Beneficiary Date"
                                                                    onChange={(e) => {
                                                                      const newValue = e.target.value !== '' ? e.target.value : null;
                                                                      setSelectedDependent({ ...selectedDependent, InsuranceDate: newValue });
                                                                    }}
                                                                  />
                                                                  {/* <input type="text" className="form-control" placeholder="Enter Insurance Date" value={selectedDependent?.InsuranceDate || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, InsuranceDate: e.target.value })} /> */}
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >Remarks</label>
                                                                    <input type="text" className="form-control" placeholder="Enter Remarks" value={selectedDependent?.Remarks || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, Remarks: e.target.value })}/>
                                                                    </div>
                                                                  </div>
                                                      </div>
                                                      <div className="row justify-content-center">
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >Company Paid</label>
                                                                  <input type="text" className="form-control" placeholder="Enter Company Paid" value={selectedDependent?.CompanyPaid || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, CompanyPaid: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                              <div className="form-group">
                                                                  <label >HMO Provider</label>
                                                                  <input type="text" className="form-control" placeholder="Enter HMO Provider" value={selectedDependent?.HMOProvider || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, HMOProvider: e.target.value })} />
                                                              </div>
                                                          </div>
                                                          <div className="col-md-4">
                                                                    <div className="form-group">
                                                                    <label >HMO Policy Number</label>
                                                                    <input type="text" className="form-control" placeholder="Enter HMO Policy Number" value={selectedDependent?.HMOPolicyNumber || ''} onChange={(e) => setSelectedDependent({ ...selectedDependent, HMOPolicyNumber: e.target.value })} />
                                                                    </div>
                                                                  </div>
                                                      </div>
                                                      <br/>
                                      </form>
                                  </Modal.Body>
                                  <Modal.Footer>
                                      <Button variant="secondary" onClick={handleCloseEditModal}>
                                          Close
                                      </Button>
                                      <Button variant="primary" onClick={handleDependentFormSubmit}>
                                          Save Changes
                                      </Button>
                                  </Modal.Footer>
                              </Modal>
                          {/* </div> */}
                                 {/* Dependent Table */}
                                 <div className='card-body'>
                                {/* <div className="card-body"> */}
                                  <div className="table-responsive">
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <th scope="col">Action</th>
                                          <th scope="col">Full Name</th>
                                          <th scope="col">Phone Number</th>
                                          <th scope="col">Relationship</th>
                                          <th scope="col">Date of Birth</th>
                                          <th scope="col">Occupation</th>
                                          <th scope="col">Address</th>
                                          <th scope="col">City</th>
                                          <th scope="col">Province</th>
                                          <th scope="col">Postal Code</th>
                                          <th scope="col">Beneficiary</th>
                                          <th scope="col">Beneficiary Date</th>
                                          <th scope="col">Type of Coverage</th>
                                          <th scope="col">Insurance</th>
                                          <th scope="col">Insurance Date</th>
                                          <th scope="col">Remarks</th>
                                          <th scope="col">Company Paid</th>
                                          <th scope="col">HMO Provider</th>
                                          <th scope="col">HMO Policy Number</th>
                                          <th scope="col">Timestamp</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                        {filteredDependents.length > 0 ? (
                          filteredDependents.map((dependent, index) => (
                            <tr key={index}>
                              <td>
                              <button className="btn btn-xs btn-primary mr-2" onClick={() => handleShowEditModal(dependent)}>
                                      <i className="fas fa-pencil-alt"></i>
                              </button>
                                </td>
                              <td>{dependent.FullName}</td>
                              <td>{dependent.PhoneNum}</td>
                              <td>{dependent.Relationship}</td>
                              <td>{dependent.DateOfBirth}</td>
                              <td>{dependent.Occupation}</td>
                              <td>{dependent.Address}</td>
                              <td>{dependent.City}</td>
                              <td>{dependent.DepProvince}</td>
                              <td>{dependent.PostalCode}</td>
                              <td>{dependent.Beneficiary}</td>
                              <td>{dependent.BeneficiaryDate}</td>
                              <td>{dependent.TypeOfCoverage}</td>
                              <td>{dependent.Insurance}</td>
                              <td>{dependent.InsuranceDate}</td>
                              <td>{dependent.Remarks}</td>
                              <td>{dependent.CompanyPaid}</td>
                              <td>{dependent.HMOProvider}</td>
                              <td>{dependent.HMOPolicyNumber}</td>
                              <td>{dependent.CreatedAt}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="19">No dependents data yet.</td>
                          </tr>
                        )}
                      </tbody>
                     </table>
                    </div>
                  </div>
                <br/>
                      </div>
                      <div className="tab-pane fade" id="compBen" role="tabpanel" aria-labelledby="compBen-tab">
                                <div className="card-body d-flex justify-content-between align-items-center">
                                  {/* New Record button */}
                                  <button className="btn btn-xs btn-primary mr-2" onClick={handleShowAddCompBenModal}>
                                    <i className="fas fa-plus"></i> New Record
                                  </button>
                                </div>
                              {/* Add CompBen Modal */}
                              <Modal show={showAddCompBenModal} onHide={handleCloseAddModal} dialogClassName="custom-modal">
                                  <Modal.Header>
                                      <Modal.Title>Add Compensation Benefit</Modal.Title>
                                      <Button variant="default" onClick={handleCloseAddModal}> X </Button>
                                  </Modal.Header>
                                  <Modal.Body>
                                      {/*  adding of  compensation benefit form*/}
                                      <form>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Salary</label>
                                                <input type="number" className="form-control" value={compBenData.Salary} placeholder="Enter Salary" name="Salary" onChange={handleInputCompBenChange} />
                                                {errors.Salary && <div className="text-danger">{errors.Salary}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Daily Equivalent</label>
                                                <input type="number" className="form-control" value={compBenData.DailyEquivalent} placeholder="Enter Daily Equivalent" name="DailyEquivalent" onChange={handleInputCompBenChange} />
                                                {errors.DailyEquivalent && <div className="text-danger">{errors.DailyEquivalent}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Monthly Equivalent</label>
                                                <input type="number" className="form-control" value={compBenData.MonthlyEquivalent} placeholder="Enter Monthly Equivalent" name="MonthlyEquivalent" onChange={handleInputCompBenChange} />
                                                {errors.MonthlyEquivalent && <div className="text-danger">{errors.MonthlyEquivalent}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Annual Equivalent</label>
                                                <input type="number" className="form-control" value={compBenData.AnnualEquivalent} placeholder="Enter Annual Equivalent" name="AnnualEquivalent" onChange={handleInputCompBenChange} />
                                                {errors.AnnualEquivalent && <div className="text-danger">{errors.AnnualEquivalent}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Rice Monthly</label>
                                                <input type="number" className="form-control" value={compBenData.RiceMonthly} placeholder="Enter Rice Monthly" name="RiceMonthly" onChange={handleInputCompBenChange} />
                                                {errors.RiceMonthly && <div className="text-danger">{errors.RiceMonthly}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Rice Annual</label>
                                                <input type="number" className="form-control" value={compBenData.RiceAnnual} placeholder="Enter Rice Annual" name="RiceAnnual" onChange={handleInputCompBenChange} />
                                                {errors.RiceAnnual && <div className="text-danger">{errors.RiceAnnual}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Rice Differential Annual</label>
                                                <input type="number" className="form-control" value={compBenData.RiceDifferentialAnnual} placeholder="Enter Rice Differential Annual" name="RiceDifferentialAnnual" onChange={handleInputCompBenChange} />
                                                {errors.RiceDifferentialAnnual && <div className="text-danger">{errors.RiceDifferentialAnnual}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Uniform Annual</label>
                                                <input type="number" className="form-control" value={compBenData.UniformAnnual} placeholder="Enter Uniform Annual" name="UniformAnnual" onChange={handleInputCompBenChange} />
                                                {errors.UniformAnnual && <div className="text-danger">{errors.UniformAnnual}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Leave Days</label>
                                                <input type="number" className="form-control" value={compBenData.LeaveDays} placeholder="Enter Leave Days" name="LeaveDays" onChange={handleInputCompBenChange} />
                                                {errors.LeaveDays && <div className="text-danger">{errors.LeaveDays}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Laundry Allowance</label>
                                                <input type="number" className="form-control" value={compBenData.LaundryAllowance} placeholder="Enter Laundry Allowance" name="LaundryAllowance" onChange={handleInputCompBenChange} />
                                                {errors.LaundryAllowance && <div className="text-danger">{errors.LaundryAllowance}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Comm Allowance</label>
                                                <input type="number" className="form-control" value={compBenData.CommAllowance} placeholder="Enter Comm Allowance" name="CommAllowance" onChange={handleInputCompBenChange} />
                                                {errors.CommAllowance && <div className="text-danger">{errors.CommAllowance}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Comm Allowance Type</label>
                                                <input type="text" className="form-control" value={compBenData.CommAllowanceType} placeholder="Enter Comm Allowance Type" name="CommAllowanceType" onChange={handleInputCompBenChange} />
                                                {errors.CommAllowanceType && <div className="text-danger">{errors.CommAllowanceType}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Cash Gift</label>
                                                <input type="number" className="form-control" value={compBenData.CashGift} placeholder="Enter Cash Gift" name="CashGift" onChange={handleInputCompBenChange} />
                                                {errors.CashGift && <div className="text-danger">{errors.CashGift}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Medical Insurance</label>
                                                <input type="number" className="form-control" value={compBenData.MedicalInsurance} placeholder="Enter Medical Insurance" name="MedicalInsurance" onChange={handleInputCompBenChange} />
                                                {errors.MedicalInsurance && <div className="text-danger">{errors.MedicalInsurance}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Free HMO Dependent</label>
                                                <input type="number" className="form-control" value={compBenData.FreeHMODependent} placeholder="Enter Free HMO Dependent" name="FreeHMODependent" onChange={handleInputCompBenChange} />
                                                {errors.FreeHMODependent && <div className="text-danger">{errors.FreeHMODependent}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>MBL</label>
                                                <input type="number" className="form-control" value={compBenData.MBL} placeholder="Enter MBL" name="MBL" onChange={handleInputCompBenChange} />
                                                {errors.MBL && <div className="text-danger">{errors.MBL}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Life Insurance</label>
                                                <input type="number" className="form-control" value={compBenData.LifeInsurance} placeholder="Enter Life Insurance" name="LifeInsurance" onChange={handleInputCompBenChange} />
                                                {errors.LifeInsurance && <div className="text-danger">{errors.LifeInsurance}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Beneficiaries</label>
                                                <input type="text" className="form-control" value={compBenData.Beneficiaries} placeholder="Enter Beneficiaries" name="Beneficiaries" onChange={handleInputCompBenChange} />
                                                {errors.Beneficiaries && <div className="text-danger">{errors.Beneficiaries}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Personal Accident Insurance Benefit</label>
                                                <input type="number" className="form-control" value={compBenData.PersonalAccidentInsuranceBenefit} placeholder="Enter Personal Accident Insurance Benefit" name="PersonalAccidentInsuranceBenefit" onChange={handleInputCompBenChange} />
                                                {errors.PersonalAccidentInsuranceBenefit && <div className="text-danger">{errors.PersonalAccidentInsuranceBenefit}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>PWD ID Number</label>
                                                <input type="text" className="form-control" value={compBenData.PWDIDNumber} placeholder="Enter PWD ID Number" name="PWDIDNumber" onChange={handleInputCompBenChange} />
                                                {errors.PWDIDNumber && <div className="text-danger">{errors.PWDIDNumber}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Tendopay Registered</label>
                                                <input type="text" className="form-control" value={compBenData.TendopayRegistered} placeholder="Enter Tendopay Registered" name="TendopayRegistered" onChange={handleInputCompBenChange} />
                                                {errors.TendopayRegistered && <div className="text-danger">{errors.TendopayRegistered}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Canteen UID</label>
                                                <input type="text" className="form-control" value={compBenData.CanteenUID} placeholder="Enter Canteen UID" name="CanteenUID" onChange={handleInputCompBenChange} />
                                                {errors.CanteenUID && <div className="text-danger">{errors.CanteenUID}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Canteen Credit Limit</label>
                                                <input type="number" className="form-control" value={compBenData.CanteenCreditLimit} placeholder="Enter Canteen Credit Limit" name="CanteenCreditLimit" onChange={handleInputCompBenChange} />
                                                {errors.CanteenCreditLimit && <div className="text-danger">{errors.CanteenCreditLimit}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Canteen Barcode</label>
                                                <input type="text" className="form-control" value={compBenData.CanteenBarcode} placeholder="Enter Canteen Barcode" name="CanteenBarcode" onChange={handleInputCompBenChange} />
                                                {errors.CanteenBarcode && <div className="text-danger">{errors.CanteenBarcode}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>DAP Membership Number</label>
                                                <input type="text" className="form-control" value={compBenData.DAPMembershipNumber} placeholder="Enter DAP Membership Number" name="DAPMembershipNumber" onChange={handleInputCompBenChange} />
                                                {errors.DAPMembershipNumber && <div className="text-danger">{errors.DAPMembershipNumber}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>DAP Dependents</label>
                                                <input type="text" className="form-control" value={compBenData.DAPDependents} placeholder="Enter DAP Dependents" name="DAPDependents" onChange={handleInputCompBenChange} />
                                                {errors.DAPDependents && <div className="text-danger">{errors.DAPDependents}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>SSS Number</label>
                                                <input type="text" className="form-control" value={compBenData.Stat_SSSNumber} placeholder="Enter SSS Number" name="Stat_SSSNumber" onChange={handleInputCompBenChange} />
                                                {errors.Stat_SSSNumber && <div className="text-danger">{errors.Stat_SSSNumber}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>SSS Monthly Contribution</label>
                                                <input type="number" className="form-control" value={compBenData.Stat_SSSMonthlyContribution} placeholder="Enter SSS Monthly Contribution" name="Stat_SSSMonthlyContribution" onChange={handleInputCompBenChange} />
                                                {errors.Stat_SSSMonthlyContribution && <div className="text-danger">{errors.Stat_SSSMonthlyContribution}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Pag-IBIG Number</label>
                                                <input type="text" className="form-control" value={compBenData.Stat_PagIbigNumber} placeholder="Enter Pag-IBIG Number" name="Stat_PagIbigNumber" onChange={handleInputCompBenChange} />
                                                {errors.Stat_PagIbigNumber && <div className="text-danger">{errors.Stat_PagIbigNumber}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>Pag-IBIG Monthly Contribution</label>
                                                <input type="number" className="form-control" value={compBenData.Stat_PagIbigMonthlyContribution} placeholder="Enter Pag-IBIG Monthly Contribution" name="Stat_PagIbigMonthlyContribution" onChange={handleInputCompBenChange} />
                                                {errors.Stat_PagIbigMonthlyContribution && <div className="text-danger">{errors.Stat_PagIbigMonthlyContribution}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row justify-content-center">
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>PHIC Number</label>
                                                <input type="text" className="form-control" value={compBenData.Stat_PHICNumber} placeholder="Enter PHIC Number" name="Stat_PHICNumber" onChange={handleInputCompBenChange} />
                                                {errors.Stat_PHICNumber && <div className="text-danger">{errors.Stat_PHICNumber}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>PHIC Monthly Contribution</label>
                                                <input type="number" className="form-control" value={compBenData.Stat_PHICMonthlyContribution} placeholder="Enter PHIC Monthly Contribution" name="Stat_PHICMonthlyContribution" onChange={handleInputCompBenChange} />
                                                {errors.Stat_PHICMonthlyContribution && <div className="text-danger">{errors.Stat_PHICMonthlyContribution}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div className="form-group">
                                                <label>TIN Number</label>
                                                <input type="text" className="form-control" value={compBenData.Stat_TINNumber} placeholder="Enter TIN Number" name="Stat_TINNumber" onChange={handleInputCompBenChange} />
                                                {errors.Stat_TINNumber && <div className="text-danger">{errors.Stat_TINNumber}</div>}
                                              </div>
                                            </div>
                                          </div>
                                          <br/>
                                        </form>
                                  </Modal.Body>
                                  <Modal.Footer>
                                      <Button variant="secondary" onClick={handleCloseAddModal}>
                                          Close
                                      </Button>
                                      <Button variant="primary" onClick={handleAddCompBen}>
                                          Add Compensation Benefit
                                      </Button>
                                  </Modal.Footer>
                              </Modal>
                              {/* Edit Compensation Benefit Modal */}
                            <Modal show={!!selectedCompBen} onHide={handleCloseEditCompBenModal} dialogClassName="custom-modal">
                              <Modal.Header>
                                <Modal.Title>Update CompBen Records</Modal.Title>
                                <Button variant="default" onClick={handleCloseEditCompBenModal}> X </Button>
                              </Modal.Header>
                              <Modal.Body>
                                      {/*  edit compensation benefits form*/}
                                      <form>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Salary</label>
                                            {shouldShowSalary(employeeData.Level) ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Salary"
                                                value={selectedCompBen?.Salary || ''}
                                                onChange={(e) => setSelectedCompBen({ ...selectedCompBen, Salary: e.target.value })}
                                              />
                                            ) : (
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Salary Hidden"
                                                disabled
                                              />
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Daily Equivalent</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Daily Equivalent"
                                              value={selectedCompBen?.DailyEquivalent || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  DailyEquivalent: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Monthly Equivalent</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Monthly Equivalent"
                                              value={selectedCompBen?.MonthlyEquivalent || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  MonthlyEquivalent: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Annual Equivalent</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Annual Equivalent"
                                              value={selectedCompBen?.AnnualEquivalent || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  AnnualEquivalent: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Rice Monthly</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Rice Monthly"
                                              value={selectedCompBen?.RiceMonthly || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  RiceMonthly: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Rice Annual</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Rice Annual"
                                              value={selectedCompBen?.RiceAnnual || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({ ...selectedCompBen, RiceAnnual: e.target.value })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Rice Differential Annual</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Rice Differential Annual"
                                              value={selectedCompBen?.RiceDifferentialAnnual || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  RiceDifferentialAnnual: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Uniform Annual</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Uniform Annual"
                                              value={selectedCompBen?.UniformAnnual || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  UniformAnnual: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Leave Days</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Leave Days"
                                              value={selectedCompBen?.LeaveDays || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({ ...selectedCompBen, LeaveDays: e.target.value })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Laundry Allowance</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Laundry Allowance"
                                              value={selectedCompBen?.LaundryAllowance || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  LaundryAllowance: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Comm Allowance</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Comm Allowance"
                                              value={selectedCompBen?.CommAllowance || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  CommAllowance: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Cash Gift</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Cash Gift"
                                              value={selectedCompBen?.CashGift || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({ ...selectedCompBen, CashGift: e.target.value })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Medical Insurance</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Medical Insurance"
                                              value={selectedCompBen?.MedicalInsurance || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  MedicalInsurance: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Free HMO Dependent</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Free HMO Dependent"
                                              value={selectedCompBen?.FreeHMODependent || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  FreeHMODependent: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>MBL</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter MBL"
                                              value={selectedCompBen?.MBL || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({ ...selectedCompBen, MBL: e.target.value })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Life Insurance</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Life Insurance"
                                              value={selectedCompBen?.LifeInsurance || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  LifeInsurance: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Personal Accident Insurance Benefit</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Personal Accident Insurance Benefit"
                                              value={selectedCompBen?.PersonalAccidentInsuranceBenefit || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  PersonalAccidentInsuranceBenefit: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>PWD ID Number</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter PWD ID Number"
                                              value={selectedCompBen?.PWDIDNumber || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  PWDIDNumber: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Tendopay Registered</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Tendopay Registered"
                                              value={selectedCompBen?.TendopayRegistered || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  TendopayRegistered: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Canteen UID</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Canteen UID"
                                              value={selectedCompBen?.CanteenUID || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  CanteenUID: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Canteen Credit Limit</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Canteen Credit Limit"
                                              value={selectedCompBen?.CanteenCreditLimit || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  CanteenCreditLimit: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Canteen Barcode</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Canteen Barcode"
                                              value={selectedCompBen?.CanteenBarcode || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  CanteenBarcode: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>DAP Membership Number</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter DAP Membership Number"
                                              value={selectedCompBen?.DAPMembershipNumber || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  DAPMembershipNumber: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>DAP Dependents</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter DAP Dependents"
                                              value={selectedCompBen?.DAPDependents || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  DAPDependents: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Stat SSS Number</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Stat SSS Number"
                                              value={selectedCompBen?.Stat_SSSNumber || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  Stat_SSSNumber: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Stat SSS Monthly Contribution</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Stat SSS Monthly Contribution"
                                              value={selectedCompBen?.Stat_SSSMonthlyContribution || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  Stat_SSSMonthlyContribution: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Stat PagIbig Number</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Stat PagIbig Number"
                                              value={selectedCompBen?.Stat_PagIbigNumber || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  Stat_PagIbigNumber: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Stat PagIbig Monthly Contribution</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Stat PagIbig Monthly Contribution"
                                              value={selectedCompBen?.Stat_PagIbigMonthlyContribution || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  Stat_PagIbigMonthlyContribution: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Stat PHIC Number</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Stat PHIC Number"
                                              value={selectedCompBen?.Stat_PHICNumber || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  Stat_PHICNumber: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Stat PHIC Monthly Contribution</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Stat PHIC Monthly Contribution"
                                              value={selectedCompBen?.Stat_PHICMonthlyContribution || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  Stat_PHICMonthlyContribution: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row justify-content-center">
                                        <div className="col-md-4">
                                          <div className="form-group">
                                            <label>Stat TIN Number</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Stat TIN Number"
                                              value={selectedCompBen?.Stat_TINNumber || ''}
                                              onChange={(e) =>
                                                setSelectedCompBen({
                                                  ...selectedCompBen,
                                                  Stat_TINNumber: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <br />
                                    </form>

                                  </Modal.Body>
                                  <Modal.Footer>
                                      <Button variant="secondary" onClick={handleCloseEditCompBenModal}>
                                          Close
                                      </Button>
                                      <Button variant="primary" onClick={handleEditCompBenFormSubmit}>
                                          Save Changes
                                      </Button>
                                  </Modal.Footer>
                              </Modal>
                          {/* </div> */}
                                 {/* Compensation Table */}
                                 <div className='card-body'>
                                {/* <div classN ame="card-body"> */}
                                  <div className="table-responsive">
                                    <table className="table">
                                      <thead>
                                        <tr>
                                        <th scope="col">Action</th>
                                        <th scope="col">Salary</th>
                                        <th scope="col">Daily Equivalent</th>
                                        <th scope="col">Monthly Equivalent</th>
                                        <th scope="col">Annual Equivalent</th>
                                        <th scope="col">Rice Monthly</th>
                                        <th scope="col">Rice Annual</th>
                                        <th scope="col">Rice Differential Annual</th>
                                        <th scope="col">Uniform Annual</th>
                                        <th scope="col">Leave Days</th>
                                        <th scope="col">Laundry Allowance</th>
                                        <th scope="col">Comm Allowance</th>
                                        <th scope="col">Comm Allowance Type</th>
                                        <th scope="col">Cash Gift</th>
                                        <th scope="col">Medical Insurance</th>
                                        <th scope="col">Free HMO Dependent</th>
                                        <th scope="col">MBL</th>
                                        <th scope="col">Life Insurance</th>
                                        <th scope="col">Beneficiaries</th>
                                        <th scope="col">Personal Accident Insurance Benefit</th>
                                        <th scope="col">PWD ID Number</th>
                                        <th scope="col">Tendopay Registered</th>
                                        <th scope="col">Canteen UID</th>
                                        <th scope="col">Canteen Credit Limit</th>
                                        <th scope="col">Canteen Barcode</th>
                                        <th scope="col">DAP Membership Number</th>
                                        <th scope="col">DAP Dependents</th>
                                        <th scope="col">Stat SSS Number</th>
                                        <th scope="col">Stat SSS Monthly Contribution</th>
                                        <th scope="col">Stat PagIbig Number</th>
                                        <th scope="col">Stat PagIbig Monthly Contribution</th>
                                        <th scope="col">Stat PHIC Number</th>
                                        <th scope="col">Stat PHIC Monthly Contribution</th>
                                        <th scope="col">Stat TIN Number</th>
                                        <th scope="col">Created at</th>
                                        </tr>
                                      </thead>
                                      <tbody>
        {filteredCompBen.length > 0 ? renderCompBenRows() : (
          <tr>
            <td colSpan="36">No compensation benefit data yet.</td>
          </tr>
        )}
      </tbody>
                                    </table>
                                  </div>
                           </div>
                      <br/>
                      </div>
                      <div className='tab-pane fade' id='history' role='tabpanel' aria-labelledby='history-tab'>
                         {/* History Table */}
                         <div className='card-body'>
                         <button
                        className="btn btn-primary mr-2"
                        onClick={handleDownloadExcel}
                      >
                        <i className="fas fa-arrow-down"></i> History Record
                      </button>
                      <br/>
                      <hr/>
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">Employee ID</th>
                                  <th scope="col">Employee Name</th>
                                  <th scope="col">Field Name</th>
                                  <th scope="col">Action</th>
                                  <th scope="col">Old</th>
                                  <th scope="col">New</th>
                                  <th scope="col">Remarks</th>
                                  <th scope="col">Date Created</th>
                                  <th scope="col">Updated By</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredHistory.length > 0 ? (
                                  filteredHistory.map((history, index) => (
                                    <tr key={index}>
                                    <td>{history.EmployeeId}</td>
                                    <td>{toSentenceCase(history.EmployeeName)}</td>
                                    <td>{toSentenceCase(history.FieldName)}</td>
                                    <td>{toSentenceCase(history.Action)}</td>
                                    <td>{history.OldValue}</td>
                                    <td>{history.NewValue}</td>
                                    <td>{toSentenceCase(history.Remarks)}</td>
                                    <td>{history.DateCreated}</td>
                                    <td>{toSentenceCase(history.UpdatedBy)}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="8">No history data available.</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
     </div>
    <Footer />
  </div>
 </div>
  );
}

export default UpdateEmployeeInfo;